/* eslint-disable */ 
 /* 🤖 This is an generated file, do not alter it directly! 👮 */ 
 //@ts-nocheck 

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  I18NLocaleCode: any;
  JSON: any;
  PageBlocksDynamicZoneInput: any;
  StoryBlocksDynamicZoneInput: any;
  Upload: any;
};

export type IAwesomeHelpHelp = {
  __typename?: 'AwesomeHelpHelp';
  componentName?: Maybe<Scalars['String']>;
  containerType?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  fieldName?: Maybe<Scalars['String']>;
  helpContent?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zoneName?: Maybe<Scalars['String']>;
};

export type IAwesomeHelpHelpEntity = {
  __typename?: 'AwesomeHelpHelpEntity';
  attributes?: Maybe<IAwesomeHelpHelp>;
  id?: Maybe<Scalars['ID']>;
};

export type IAwesomeHelpHelpEntityResponse = {
  __typename?: 'AwesomeHelpHelpEntityResponse';
  data?: Maybe<IAwesomeHelpHelpEntity>;
};

export type IAwesomeHelpHelpEntityResponseCollection = {
  __typename?: 'AwesomeHelpHelpEntityResponseCollection';
  data: Array<IAwesomeHelpHelpEntity>;
  meta: IResponseCollectionMeta;
};

export type IAwesomeHelpHelpFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IAwesomeHelpHelpFiltersInput>>>;
  componentName?: InputMaybe<IStringFilterInput>;
  containerType?: InputMaybe<IStringFilterInput>;
  contentType?: InputMaybe<IStringFilterInput>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  fieldName?: InputMaybe<IStringFilterInput>;
  helpContent?: InputMaybe<IStringFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  not?: InputMaybe<IAwesomeHelpHelpFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IAwesomeHelpHelpFiltersInput>>>;
  path?: InputMaybe<IStringFilterInput>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
  zoneName?: InputMaybe<IStringFilterInput>;
};

export type IAwesomeHelpHelpInput = {
  componentName?: InputMaybe<Scalars['String']>;
  containerType?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  fieldName?: InputMaybe<Scalars['String']>;
  helpContent?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  zoneName?: InputMaybe<Scalars['String']>;
};

export type IBooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  contains?: InputMaybe<Scalars['Boolean']>;
  containsi?: InputMaybe<Scalars['Boolean']>;
  endsWith?: InputMaybe<Scalars['Boolean']>;
  eq?: InputMaybe<Scalars['Boolean']>;
  eqi?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nei?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<IBooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']>;
  notContainsi?: InputMaybe<Scalars['Boolean']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']>;
};

export type ICard = {
  __typename?: 'Card';
  Card?: Maybe<IComponentSharedCards>;
  createdAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<ICardRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ICardLocalizationsArgs = {
  filters?: InputMaybe<ICardFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ICardCollection = {
  __typename?: 'CardCollection';
  cards?: Maybe<ICardRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<ICardCollectionRelationResponseCollection>;
  reverseOrderOnMobile?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ICardCollectionCardsArgs = {
  filters?: InputMaybe<ICardFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ICardCollectionLocalizationsArgs = {
  filters?: InputMaybe<ICardCollectionFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ICardCollectionEntity = {
  __typename?: 'CardCollectionEntity';
  attributes?: Maybe<ICardCollection>;
  id?: Maybe<Scalars['ID']>;
};

export type ICardCollectionEntityResponse = {
  __typename?: 'CardCollectionEntityResponse';
  data?: Maybe<ICardCollectionEntity>;
};

export type ICardCollectionEntityResponseCollection = {
  __typename?: 'CardCollectionEntityResponseCollection';
  data: Array<ICardCollectionEntity>;
  meta: IResponseCollectionMeta;
};

export type ICardCollectionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ICardCollectionFiltersInput>>>;
  cards?: InputMaybe<ICardFiltersInput>;
  cmsTitle?: InputMaybe<IStringFilterInput>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  locale?: InputMaybe<IStringFilterInput>;
  localizations?: InputMaybe<ICardCollectionFiltersInput>;
  not?: InputMaybe<ICardCollectionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ICardCollectionFiltersInput>>>;
  reverseOrderOnMobile?: InputMaybe<IBooleanFilterInput>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
};

export type ICardCollectionInput = {
  cards?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  cmsTitle?: InputMaybe<Scalars['String']>;
  reverseOrderOnMobile?: InputMaybe<Scalars['Boolean']>;
};

export type ICardCollectionRelationResponseCollection = {
  __typename?: 'CardCollectionRelationResponseCollection';
  data: Array<ICardCollectionEntity>;
};

export type ICardEntity = {
  __typename?: 'CardEntity';
  attributes?: Maybe<ICard>;
  id?: Maybe<Scalars['ID']>;
};

export type ICardEntityResponse = {
  __typename?: 'CardEntityResponse';
  data?: Maybe<ICardEntity>;
};

export type ICardEntityResponseCollection = {
  __typename?: 'CardEntityResponseCollection';
  data: Array<ICardEntity>;
  meta: IResponseCollectionMeta;
};

export type ICardFiltersInput = {
  Card?: InputMaybe<IComponentSharedCardsFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ICardFiltersInput>>>;
  cmsTitle?: InputMaybe<IStringFilterInput>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  locale?: InputMaybe<IStringFilterInput>;
  localizations?: InputMaybe<ICardFiltersInput>;
  not?: InputMaybe<ICardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ICardFiltersInput>>>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
};

export type ICardInput = {
  Card?: InputMaybe<IComponentSharedCardsInput>;
  cmsTitle?: InputMaybe<Scalars['String']>;
};

export type ICardRelationResponseCollection = {
  __typename?: 'CardRelationResponseCollection';
  data: Array<ICardEntity>;
};

export type IComponentBlocksAltContent = {
  __typename?: 'ComponentBlocksAltContent';
  backgroundColour?: Maybe<IEnum_Componentblocksaltcontent_Backgroundcolour>;
  id: Scalars['ID'];
  mediaWithContent?: Maybe<IMediaWithContentRelationResponseCollection>;
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
  titleDescription?: Maybe<IComponentSharedTitleAndDescription>;
};


export type IComponentBlocksAltContentMediaWithContentArgs = {
  filters?: InputMaybe<IMediaWithContentFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentBlocksCardsBlock = {
  __typename?: 'ComponentBlocksCardsBlock';
  card_collections?: Maybe<ICardCollectionRelationResponseCollection>;
  id: Scalars['ID'];
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
  titleDescription?: Maybe<IComponentSharedTitleAndDescription>;
};


export type IComponentBlocksCardsBlockCard_CollectionsArgs = {
  filters?: InputMaybe<ICardCollectionFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentBlocksCarouselBlock = {
  __typename?: 'ComponentBlocksCarouselBlock';
  cards?: Maybe<ICardRelationResponseCollection>;
  id: Scalars['ID'];
  slidesPerView: IEnum_Componentblockscarouselblock_Slidesperview;
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
  titleDescription?: Maybe<IComponentSharedTitleAndDescription>;
};


export type IComponentBlocksCarouselBlockCardsArgs = {
  filters?: InputMaybe<ICardFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentBlocksCarouselStories = {
  __typename?: 'ComponentBlocksCarouselStories';
  id: Scalars['ID'];
  stories?: Maybe<IStoryRelationResponseCollection>;
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
  titleDescription?: Maybe<IComponentSharedTitleAndDescription>;
  variant?: Maybe<IEnum_Componentblockscarouselstories_Variant>;
};


export type IComponentBlocksCarouselStoriesStoriesArgs = {
  filters?: InputMaybe<IStoryFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  publicationState?: InputMaybe<IPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentBlocksContacts = {
  __typename?: 'ComponentBlocksContacts';
  columns: Array<Maybe<IComponentSharedContactBlockColumn>>;
  id: Scalars['ID'];
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
  titleDescription?: Maybe<IComponentSharedTitleAndDescription>;
};


export type IComponentBlocksContactsColumnsArgs = {
  filters?: InputMaybe<IComponentSharedContactBlockColumnFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentBlocksCustomerRadarFeedbackBlock = {
  __typename?: 'ComponentBlocksCustomerRadarFeedbackBlock';
  id: Scalars['ID'];
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
  titleDescription?: Maybe<IComponentSharedTitleAndDescription>;
};

export type IComponentBlocksDealsBlock = {
  __typename?: 'ComponentBlocksDealsBlock';
  id: Scalars['ID'];
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
  titleDescription?: Maybe<IComponentSharedTitleAndDescription>;
};

export type IComponentBlocksEmbedHtml = {
  __typename?: 'ComponentBlocksEmbedHtml';
  embedCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
  titleDescription?: Maybe<IComponentSharedTitleAndDescription>;
};

export type IComponentBlocksEnquiryForm = {
  __typename?: 'ComponentBlocksEnquiryForm';
  id: Scalars['ID'];
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
  titleDescription?: Maybe<IComponentSharedTitleAndDescription>;
};

export type IComponentBlocksFaq = {
  __typename?: 'ComponentBlocksFaq';
  ctaButton?: Maybe<IComponentSharedLink>;
  ctaDescription?: Maybe<Scalars['String']>;
  faqs?: Maybe<IFaqItemRelationResponseCollection>;
  id: Scalars['ID'];
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
  titleDescription?: Maybe<IComponentSharedTitleAndDescription>;
};


export type IComponentBlocksFaqFaqsArgs = {
  filters?: InputMaybe<IFaqItemFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentBlocksGallery = {
  __typename?: 'ComponentBlocksGallery';
  galleryImages: Array<Maybe<IComponentSharedImageField>>;
  id: Scalars['ID'];
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
};


export type IComponentBlocksGalleryGalleryImagesArgs = {
  filters?: InputMaybe<IComponentSharedImageFieldFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentBlocksGalleryCarousel = {
  __typename?: 'ComponentBlocksGalleryCarousel';
  eyebrowTitle?: Maybe<Scalars['String']>;
  galleryCarouselImages: IUploadFileRelationResponseCollection;
  id: Scalars['ID'];
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
};


export type IComponentBlocksGalleryCarouselGalleryCarouselImagesArgs = {
  filters?: InputMaybe<IUploadFileFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentBlocksIconCardBlock = {
  __typename?: 'ComponentBlocksIconCardBlock';
  iconCards?: Maybe<IIconCardRelationResponseCollection>;
  id: Scalars['ID'];
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
  titleDescription?: Maybe<IComponentSharedTitleAndDescription>;
};


export type IComponentBlocksIconCardBlockIconCardsArgs = {
  filters?: InputMaybe<IIconCardFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  publicationState?: InputMaybe<IPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentBlocksMap = {
  __typename?: 'ComponentBlocksMap';
  branchLocations?: Maybe<Array<Maybe<IComponentSharedBranchLocations>>>;
  customMarkers?: Maybe<Array<Maybe<IComponentSharedMapMarker>>>;
  id: Scalars['ID'];
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
};


export type IComponentBlocksMapBranchLocationsArgs = {
  filters?: InputMaybe<IComponentSharedBranchLocationsFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IComponentBlocksMapCustomMarkersArgs = {
  filters?: InputMaybe<IComponentSharedMapMarkerFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentBlocksMotorhomeDetails = {
  __typename?: 'ComponentBlocksMotorhomeDetails';
  fleet: Scalars['String'];
  id: Scalars['ID'];
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
};

export type IComponentBlocksMotorhomeInfoTabs = {
  __typename?: 'ComponentBlocksMotorhomeInfoTabs';
  id: Scalars['ID'];
  infoTabs: Array<Maybe<IComponentSharedMotorhomeInfoTab>>;
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
};


export type IComponentBlocksMotorhomeInfoTabsInfoTabsArgs = {
  filters?: InputMaybe<IComponentSharedMotorhomeInfoTabFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentBlocksRichText = {
  __typename?: 'ComponentBlocksRichText';
  id: Scalars['ID'];
  richText: Scalars['String'];
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
};

export type IComponentBlocksRichTextColumns = {
  __typename?: 'ComponentBlocksRichTextColumns';
  addBackgroundColour?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  richTextColumns: Array<Maybe<IComponentSharedRichTextColumn>>;
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
  titleDescription?: Maybe<IComponentSharedTitleAndDescription>;
};


export type IComponentBlocksRichTextColumnsRichTextColumnsArgs = {
  filters?: InputMaybe<IComponentSharedRichTextColumnFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentBlocksSocialMedia = {
  __typename?: 'ComponentBlocksSocialMedia';
  id: Scalars['ID'];
  social_posts?: Maybe<ISocialPostRelationResponseCollection>;
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
  titleDescription?: Maybe<IComponentSharedTitleAndDescription>;
};


export type IComponentBlocksSocialMediaSocial_PostsArgs = {
  filters?: InputMaybe<ISocialPostFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentBlocksStarStoryForm = {
  __typename?: 'ComponentBlocksStarStoryForm';
  aboutDescription?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  storyDescription?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<Scalars['String']>;
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
  titleDescription?: Maybe<IComponentSharedTitleAndDescription>;
  uploadDescription?: Maybe<Scalars['String']>;
};

export type IComponentBlocksStoryCardGrid = {
  __typename?: 'ComponentBlocksStoryCardGrid';
  id: Scalars['ID'];
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
  titleDescription?: Maybe<IComponentSharedTitleAndDescription>;
};

export type IComponentBlocksTabContentBlock = {
  __typename?: 'ComponentBlocksTabContentBlock';
  id: Scalars['ID'];
  tabs: Array<Maybe<IComponentSharedTab>>;
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
  titleDescription?: Maybe<IComponentSharedTitleAndDescription>;
};


export type IComponentBlocksTabContentBlockTabsArgs = {
  filters?: InputMaybe<IComponentSharedTabFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentBlocksTestimonials = {
  __typename?: 'ComponentBlocksTestimonials';
  id: Scalars['ID'];
  testimonials?: Maybe<ITestimonialRelationResponseCollection>;
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
  titleDescription?: Maybe<IComponentSharedTitleAndDescription>;
};


export type IComponentBlocksTestimonialsTestimonialsArgs = {
  filters?: InputMaybe<ITestimonialFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentBlocksVideo = {
  __typename?: 'ComponentBlocksVideo';
  id: Scalars['ID'];
  mux_video_uploader_mux_asset?: Maybe<IMuxVideoUploaderMuxAssetEntityResponse>;
  tightPaddingBelow?: Maybe<Scalars['Boolean']>;
};

export type IComponentGlobalFooter = {
  __typename?: 'ComponentGlobalFooter';
  footerColumns: Array<Maybe<IComponentSharedFooterColumn>>;
  id: Scalars['ID'];
  underFooterLinks: Array<Maybe<IComponentSharedLink>>;
};


export type IComponentGlobalFooterFooterColumnsArgs = {
  filters?: InputMaybe<IComponentSharedFooterColumnFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IComponentGlobalFooterUnderFooterLinksArgs = {
  filters?: InputMaybe<IComponentSharedLinkFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentGlobalFooterInput = {
  footerColumns?: InputMaybe<Array<InputMaybe<IComponentSharedFooterColumnInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  underFooterLinks?: InputMaybe<Array<InputMaybe<IComponentSharedLinkInput>>>;
};

export type IComponentSharedBranchLocations = {
  __typename?: 'ComponentSharedBranchLocations';
  branchLocations?: Maybe<IEnum_Componentsharedbranchlocations_Branchlocations>;
  id: Scalars['ID'];
};

export type IComponentSharedBranchLocationsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSharedBranchLocationsFiltersInput>>>;
  branchLocations?: InputMaybe<IStringFilterInput>;
  not?: InputMaybe<IComponentSharedBranchLocationsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IComponentSharedBranchLocationsFiltersInput>>>;
};

export type IComponentSharedCards = {
  __typename?: 'ComponentSharedCards';
  backgroundColour?: Maybe<IEnum_Componentsharedcards_Backgroundcolour>;
  description?: Maybe<Scalars['String']>;
  eyebrowText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<IUploadFileEntityResponse>;
  link?: Maybe<IComponentSharedLink>;
  tintImage?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  video?: Maybe<IMuxVideoUploaderMuxAssetEntityResponse>;
};

export type IComponentSharedCardsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSharedCardsFiltersInput>>>;
  backgroundColour?: InputMaybe<IStringFilterInput>;
  description?: InputMaybe<IStringFilterInput>;
  eyebrowText?: InputMaybe<IStringFilterInput>;
  link?: InputMaybe<IComponentSharedLinkFiltersInput>;
  not?: InputMaybe<IComponentSharedCardsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IComponentSharedCardsFiltersInput>>>;
  tintImage?: InputMaybe<IBooleanFilterInput>;
  title?: InputMaybe<IStringFilterInput>;
  video?: InputMaybe<IMuxVideoUploaderMuxAssetFiltersInput>;
};

export type IComponentSharedCardsInput = {
  backgroundColour?: InputMaybe<IEnum_Componentsharedcards_Backgroundcolour>;
  description?: InputMaybe<Scalars['String']>;
  eyebrowText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['ID']>;
  link?: InputMaybe<IComponentSharedLinkInput>;
  tintImage?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  video?: InputMaybe<Scalars['ID']>;
};

export type IComponentSharedContactBlockColumn = {
  __typename?: 'ComponentSharedContactBlockColumn';
  id: Scalars['ID'];
  links: Array<Maybe<IComponentSharedContactColumnLinks>>;
  title: Scalars['String'];
};


export type IComponentSharedContactBlockColumnLinksArgs = {
  filters?: InputMaybe<IComponentSharedContactColumnLinksFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentSharedContactBlockColumnFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSharedContactBlockColumnFiltersInput>>>;
  links?: InputMaybe<IComponentSharedContactColumnLinksFiltersInput>;
  not?: InputMaybe<IComponentSharedContactBlockColumnFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IComponentSharedContactBlockColumnFiltersInput>>>;
  title?: InputMaybe<IStringFilterInput>;
};

export type IComponentSharedContactColumnLinks = {
  __typename?: 'ComponentSharedContactColumnLinks';
  id: Scalars['ID'];
  link: IComponentSharedLink;
  title: Scalars['String'];
};

export type IComponentSharedContactColumnLinksFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSharedContactColumnLinksFiltersInput>>>;
  link?: InputMaybe<IComponentSharedLinkFiltersInput>;
  not?: InputMaybe<IComponentSharedContactColumnLinksFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IComponentSharedContactColumnLinksFiltersInput>>>;
  title?: InputMaybe<IStringFilterInput>;
};

export type IComponentSharedFooterColumn = {
  __typename?: 'ComponentSharedFooterColumn';
  footerTitle: Scalars['String'];
  id: Scalars['ID'];
  links: Array<Maybe<IComponentSharedLink>>;
};


export type IComponentSharedFooterColumnLinksArgs = {
  filters?: InputMaybe<IComponentSharedLinkFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentSharedFooterColumnFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSharedFooterColumnFiltersInput>>>;
  footerTitle?: InputMaybe<IStringFilterInput>;
  links?: InputMaybe<IComponentSharedLinkFiltersInput>;
  not?: InputMaybe<IComponentSharedFooterColumnFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IComponentSharedFooterColumnFiltersInput>>>;
};

export type IComponentSharedFooterColumnInput = {
  footerTitle?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  links?: InputMaybe<Array<InputMaybe<IComponentSharedLinkInput>>>;
};

export type IComponentSharedHero = {
  __typename?: 'ComponentSharedHero';
  bookingBarText?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<IComponentSharedHeroImage>;
  showBookingBar?: Maybe<Scalars['Boolean']>;
  showBreadcrumbs?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  video?: Maybe<IComponentSharedHeroVideo>;
};

export type IComponentSharedHeroFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSharedHeroFiltersInput>>>;
  bookingBarText?: InputMaybe<IStringFilterInput>;
  description?: InputMaybe<IStringFilterInput>;
  image?: InputMaybe<IComponentSharedHeroImageFiltersInput>;
  not?: InputMaybe<IComponentSharedHeroFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IComponentSharedHeroFiltersInput>>>;
  showBookingBar?: InputMaybe<IBooleanFilterInput>;
  showBreadcrumbs?: InputMaybe<IBooleanFilterInput>;
  title?: InputMaybe<IStringFilterInput>;
  video?: InputMaybe<IComponentSharedHeroVideoFiltersInput>;
};

export type IComponentSharedHeroImage = {
  __typename?: 'ComponentSharedHeroImage';
  descriptionHighlight?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image: IUploadFileEntityResponse;
  variant: IEnum_Componentsharedheroimage_Variant;
};

export type IComponentSharedHeroImageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSharedHeroImageFiltersInput>>>;
  descriptionHighlight?: InputMaybe<IStringFilterInput>;
  not?: InputMaybe<IComponentSharedHeroImageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IComponentSharedHeroImageFiltersInput>>>;
  variant?: InputMaybe<IStringFilterInput>;
};

export type IComponentSharedHeroImageInput = {
  descriptionHighlight?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['ID']>;
  variant?: InputMaybe<IEnum_Componentsharedheroimage_Variant>;
};

export type IComponentSharedHeroInput = {
  bookingBarText?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<IComponentSharedHeroImageInput>;
  showBookingBar?: InputMaybe<Scalars['Boolean']>;
  showBreadcrumbs?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  video?: InputMaybe<IComponentSharedHeroVideoInput>;
};

export type IComponentSharedHeroVideo = {
  __typename?: 'ComponentSharedHeroVideo';
  backgroundVideo?: Maybe<IMuxVideoUploaderMuxAssetEntityResponse>;
  eyebrowText?: Maybe<Scalars['String']>;
  fullVideo?: Maybe<IMuxVideoUploaderMuxAssetEntityResponse>;
  id: Scalars['ID'];
  mobileSecondaryCta?: Maybe<IComponentSharedLink>;
};

export type IComponentSharedHeroVideoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSharedHeroVideoFiltersInput>>>;
  backgroundVideo?: InputMaybe<IMuxVideoUploaderMuxAssetFiltersInput>;
  eyebrowText?: InputMaybe<IStringFilterInput>;
  fullVideo?: InputMaybe<IMuxVideoUploaderMuxAssetFiltersInput>;
  mobileSecondaryCta?: InputMaybe<IComponentSharedLinkFiltersInput>;
  not?: InputMaybe<IComponentSharedHeroVideoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IComponentSharedHeroVideoFiltersInput>>>;
};

export type IComponentSharedHeroVideoInput = {
  backgroundVideo?: InputMaybe<Scalars['ID']>;
  eyebrowText?: InputMaybe<Scalars['String']>;
  fullVideo?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  mobileSecondaryCta?: InputMaybe<IComponentSharedLinkInput>;
};

export type IComponentSharedImageField = {
  __typename?: 'ComponentSharedImageField';
  id: Scalars['ID'];
  image: IUploadFileEntityResponse;
};

export type IComponentSharedImageFieldFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSharedImageFieldFiltersInput>>>;
  not?: InputMaybe<IComponentSharedImageFieldFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IComponentSharedImageFieldFiltersInput>>>;
};

export type IComponentSharedLink = {
  __typename?: 'ComponentSharedLink';
  id: Scalars['ID'];
  label: Scalars['String'];
  linkToExternalPage?: Maybe<Scalars['String']>;
  linkToPage?: Maybe<IPageEntityResponse>;
  linkToStory?: Maybe<IStoryEntityResponse>;
};

export type IComponentSharedLinkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSharedLinkFiltersInput>>>;
  label?: InputMaybe<IStringFilterInput>;
  linkToExternalPage?: InputMaybe<IStringFilterInput>;
  linkToPage?: InputMaybe<IPageFiltersInput>;
  linkToStory?: InputMaybe<IStoryFiltersInput>;
  not?: InputMaybe<IComponentSharedLinkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IComponentSharedLinkFiltersInput>>>;
};

export type IComponentSharedLinkInput = {
  id?: InputMaybe<Scalars['ID']>;
  label?: InputMaybe<Scalars['String']>;
  linkToExternalPage?: InputMaybe<Scalars['String']>;
  linkToPage?: InputMaybe<Scalars['ID']>;
  linkToStory?: InputMaybe<Scalars['ID']>;
};

export type IComponentSharedMapMarker = {
  __typename?: 'ComponentSharedMapMarker';
  id: Scalars['ID'];
  location?: Maybe<Scalars['JSON']>;
};

export type IComponentSharedMapMarkerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSharedMapMarkerFiltersInput>>>;
  location?: InputMaybe<IJsonFilterInput>;
  locationName?: InputMaybe<IStringFilterInput>;
  not?: InputMaybe<IComponentSharedMapMarkerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IComponentSharedMapMarkerFiltersInput>>>;
};

export type IComponentSharedMetaSocial = {
  __typename?: 'ComponentSharedMetaSocial';
  description: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<IUploadFileEntityResponse>;
  socialNetwork: IEnum_Componentsharedmetasocial_Socialnetwork;
  title: Scalars['String'];
};

export type IComponentSharedMetaSocialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSharedMetaSocialFiltersInput>>>;
  description?: InputMaybe<IStringFilterInput>;
  not?: InputMaybe<IComponentSharedMetaSocialFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IComponentSharedMetaSocialFiltersInput>>>;
  socialNetwork?: InputMaybe<IStringFilterInput>;
  title?: InputMaybe<IStringFilterInput>;
};

export type IComponentSharedMetaSocialInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['ID']>;
  socialNetwork?: InputMaybe<IEnum_Componentsharedmetasocial_Socialnetwork>;
  title?: InputMaybe<Scalars['String']>;
};

export type IComponentSharedMotorhomeInfoTab = {
  __typename?: 'ComponentSharedMotorhomeInfoTab';
  highlight?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type IComponentSharedMotorhomeInfoTabFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSharedMotorhomeInfoTabFiltersInput>>>;
  highlight?: InputMaybe<IStringFilterInput>;
  not?: InputMaybe<IComponentSharedMotorhomeInfoTabFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IComponentSharedMotorhomeInfoTabFiltersInput>>>;
};

export type IComponentSharedPartnerLink = {
  __typename?: 'ComponentSharedPartnerLink';
  id: Scalars['ID'];
  image?: Maybe<IUploadFileEntityResponse>;
  openInNew?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type IComponentSharedPartnerLinkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSharedPartnerLinkFiltersInput>>>;
  not?: InputMaybe<IComponentSharedPartnerLinkFiltersInput>;
  openInNew?: InputMaybe<IBooleanFilterInput>;
  or?: InputMaybe<Array<InputMaybe<IComponentSharedPartnerLinkFiltersInput>>>;
  title?: InputMaybe<IStringFilterInput>;
  url?: InputMaybe<IStringFilterInput>;
};

export type IComponentSharedPartnerLinkInput = {
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['ID']>;
  openInNew?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type IComponentSharedRichTextColumn = {
  __typename?: 'ComponentSharedRichTextColumn';
  id: Scalars['ID'];
  richText: Scalars['String'];
};

export type IComponentSharedRichTextColumnFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSharedRichTextColumnFiltersInput>>>;
  cmsTitle?: InputMaybe<IStringFilterInput>;
  not?: InputMaybe<IComponentSharedRichTextColumnFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IComponentSharedRichTextColumnFiltersInput>>>;
  richText?: InputMaybe<IStringFilterInput>;
};

export type IComponentSharedSeo = {
  __typename?: 'ComponentSharedSeo';
  canonicalURL?: Maybe<Scalars['String']>;
  customLdJson?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  keywords?: Maybe<Scalars['String']>;
  metaDescription: Scalars['String'];
  metaImage?: Maybe<IUploadFileEntityResponse>;
  metaRobots?: Maybe<Scalars['String']>;
  metaSocial?: Maybe<Array<Maybe<IComponentSharedMetaSocial>>>;
  metaTitle: Scalars['String'];
};


export type IComponentSharedSeoMetaSocialArgs = {
  filters?: InputMaybe<IComponentSharedMetaSocialFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentSharedSeoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSharedSeoFiltersInput>>>;
  canonicalURL?: InputMaybe<IStringFilterInput>;
  customLdJson?: InputMaybe<IJsonFilterInput>;
  keywords?: InputMaybe<IStringFilterInput>;
  metaDescription?: InputMaybe<IStringFilterInput>;
  metaRobots?: InputMaybe<IStringFilterInput>;
  metaSocial?: InputMaybe<IComponentSharedMetaSocialFiltersInput>;
  metaTitle?: InputMaybe<IStringFilterInput>;
  not?: InputMaybe<IComponentSharedSeoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IComponentSharedSeoFiltersInput>>>;
};

export type IComponentSharedSeoInput = {
  canonicalURL?: InputMaybe<Scalars['String']>;
  customLdJson?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['ID']>;
  keywords?: InputMaybe<Scalars['String']>;
  metaDescription?: InputMaybe<Scalars['String']>;
  metaImage?: InputMaybe<Scalars['ID']>;
  metaRobots?: InputMaybe<Scalars['String']>;
  metaSocial?: InputMaybe<Array<InputMaybe<IComponentSharedMetaSocialInput>>>;
  metaTitle?: InputMaybe<Scalars['String']>;
};

export type IComponentSharedSocialNetworks = {
  __typename?: 'ComponentSharedSocialNetworks';
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type IComponentSharedStoryCard = {
  __typename?: 'ComponentSharedStoryCard';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<IUploadFileEntityResponse>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type IComponentSharedTab = {
  __typename?: 'ComponentSharedTab';
  columns?: Maybe<Array<Maybe<IComponentSharedRichTextColumn>>>;
  headingLevel?: Maybe<IEnum_Componentsharedtab_Headinglevel>;
  id: Scalars['ID'];
  title: Scalars['String'];
};


export type IComponentSharedTabColumnsArgs = {
  filters?: InputMaybe<IComponentSharedRichTextColumnFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IComponentSharedTabFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IComponentSharedTabFiltersInput>>>;
  columns?: InputMaybe<IComponentSharedRichTextColumnFiltersInput>;
  headingLevel?: InputMaybe<IStringFilterInput>;
  not?: InputMaybe<IComponentSharedTabFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IComponentSharedTabFiltersInput>>>;
  title?: InputMaybe<IStringFilterInput>;
};

export type IComponentSharedTitleAndDescription = {
  __typename?: 'ComponentSharedTitleAndDescription';
  button?: Maybe<IComponentSharedLink>;
  description?: Maybe<Scalars['String']>;
  eyebrow?: Maybe<Scalars['String']>;
  headingLevel?: Maybe<IEnum_Componentsharedtitleanddescription_Headinglevel>;
  id: Scalars['ID'];
  leftAligned?: Maybe<Scalars['Boolean']>;
  showSocialMediaButtons?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type ICustomerRadarFeedback = {
  __typename?: 'CustomerRadarFeedback';
  author: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  countryOfOrigin?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['Date']>;
  fleetCategory?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  quote: Scalars['String'];
  rating: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ICustomerRadarFeedbackEntity = {
  __typename?: 'CustomerRadarFeedbackEntity';
  attributes?: Maybe<ICustomerRadarFeedback>;
  id?: Maybe<Scalars['ID']>;
};

export type ICustomerRadarFeedbackEntityResponse = {
  __typename?: 'CustomerRadarFeedbackEntityResponse';
  data?: Maybe<ICustomerRadarFeedbackEntity>;
};

export type ICustomerRadarFeedbackEntityResponseCollection = {
  __typename?: 'CustomerRadarFeedbackEntityResponseCollection';
  data: Array<ICustomerRadarFeedbackEntity>;
  meta: IResponseCollectionMeta;
};

export type ICustomerRadarFeedbackFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ICustomerRadarFeedbackFiltersInput>>>;
  author?: InputMaybe<IStringFilterInput>;
  country?: InputMaybe<IStringFilterInput>;
  countryOfOrigin?: InputMaybe<IStringFilterInput>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  date?: InputMaybe<IDateFilterInput>;
  fleetCategory?: InputMaybe<IStringFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  not?: InputMaybe<ICustomerRadarFeedbackFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ICustomerRadarFeedbackFiltersInput>>>;
  publishedAt?: InputMaybe<IDateTimeFilterInput>;
  quote?: InputMaybe<IStringFilterInput>;
  rating?: InputMaybe<IIntFilterInput>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
};

export type ICustomerRadarFeedbackInput = {
  author?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryOfOrigin?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  fleetCategory?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  quote?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['Int']>;
};

export type IDateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  contains?: InputMaybe<Scalars['Date']>;
  containsi?: InputMaybe<Scalars['Date']>;
  endsWith?: InputMaybe<Scalars['Date']>;
  eq?: InputMaybe<Scalars['Date']>;
  eqi?: InputMaybe<Scalars['Date']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  nei?: InputMaybe<Scalars['Date']>;
  not?: InputMaybe<IDateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']>;
  notContainsi?: InputMaybe<Scalars['Date']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  startsWith?: InputMaybe<Scalars['Date']>;
};

export type IDateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  contains?: InputMaybe<Scalars['DateTime']>;
  containsi?: InputMaybe<Scalars['DateTime']>;
  endsWith?: InputMaybe<Scalars['DateTime']>;
  eq?: InputMaybe<Scalars['DateTime']>;
  eqi?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  ne?: InputMaybe<Scalars['DateTime']>;
  nei?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<IDateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']>;
  notContainsi?: InputMaybe<Scalars['DateTime']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']>;
};

export enum IEnum_Componentblocksaltcontent_Backgroundcolour {
  Shell = 'shell'
}

export enum IEnum_Componentblockscarouselblock_Slidesperview {
  Four = 'Four',
  Full = 'Full',
  Three = 'Three',
  Two = 'Two'
}

export enum IEnum_Componentblockscarouselstories_Variant {
  CenteredSlider = 'CenteredSlider',
  LeftSlider = 'LeftSlider'
}

export enum IEnum_Componentsharedbranchlocations_Branchlocations {
  AdelaideAirport = 'Adelaide_Airport',
  AucklandAirport = 'Auckland_Airport',
  Brisbane = 'Brisbane',
  Cairns = 'Cairns',
  ChristchurchAirport = 'Christchurch_Airport',
  Darwin = 'Darwin',
  GoldCoast = 'Gold_Coast',
  MelbourneAirport = 'Melbourne_Airport',
  PerthAirport = 'Perth_Airport',
  QueenstownAirport = 'Queenstown_Airport',
  Sydney = 'Sydney'
}

export enum IEnum_Componentsharedcards_Backgroundcolour {
  Sand = 'sand',
  Shell = 'shell'
}

export enum IEnum_Componentsharedheroimage_Variant {
  Detail = 'detail',
  Landing = 'landing'
}

export enum IEnum_Componentsharedmetasocial_Socialnetwork {
  Facebook = 'Facebook',
  Twitter = 'Twitter'
}

export enum IEnum_Componentsharedtab_Headinglevel {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  H6 = 'h6'
}

export enum IEnum_Componentsharedtitleanddescription_Headinglevel {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  H6 = 'h6'
}

export enum IEnum_Mediawithcontent_Mediaalignment {
  Left = 'left',
  Right = 'right'
}

export type IError = {
  __typename?: 'Error';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type IFaqItem = {
  __typename?: 'FaqItem';
  answer: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  question: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IFaqItemEntity = {
  __typename?: 'FaqItemEntity';
  attributes?: Maybe<IFaqItem>;
  id?: Maybe<Scalars['ID']>;
};

export type IFaqItemEntityResponse = {
  __typename?: 'FaqItemEntityResponse';
  data?: Maybe<IFaqItemEntity>;
};

export type IFaqItemEntityResponseCollection = {
  __typename?: 'FaqItemEntityResponseCollection';
  data: Array<IFaqItemEntity>;
  meta: IResponseCollectionMeta;
};

export type IFaqItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IFaqItemFiltersInput>>>;
  answer?: InputMaybe<IStringFilterInput>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  not?: InputMaybe<IFaqItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IFaqItemFiltersInput>>>;
  question?: InputMaybe<IStringFilterInput>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
};

export type IFaqItemInput = {
  answer?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Scalars['String']>;
};

export type IFaqItemRelationResponseCollection = {
  __typename?: 'FaqItemRelationResponseCollection';
  data: Array<IFaqItemEntity>;
};

export type IFileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type IFloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  contains?: InputMaybe<Scalars['Float']>;
  containsi?: InputMaybe<Scalars['Float']>;
  endsWith?: InputMaybe<Scalars['Float']>;
  eq?: InputMaybe<Scalars['Float']>;
  eqi?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nei?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<IFloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']>;
  notContainsi?: InputMaybe<Scalars['Float']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  startsWith?: InputMaybe<Scalars['Float']>;
};

export type IGenericMorph = IAwesomeHelpHelp | ICard | ICardCollection | IComponentBlocksAltContent | IComponentBlocksCardsBlock | IComponentBlocksCarouselBlock | IComponentBlocksCarouselStories | IComponentBlocksContacts | IComponentBlocksCustomerRadarFeedbackBlock | IComponentBlocksDealsBlock | IComponentBlocksEmbedHtml | IComponentBlocksEnquiryForm | IComponentBlocksFaq | IComponentBlocksGallery | IComponentBlocksGalleryCarousel | IComponentBlocksIconCardBlock | IComponentBlocksMap | IComponentBlocksMotorhomeDetails | IComponentBlocksMotorhomeInfoTabs | IComponentBlocksRichText | IComponentBlocksRichTextColumns | IComponentBlocksSocialMedia | IComponentBlocksStarStoryForm | IComponentBlocksStoryCardGrid | IComponentBlocksTabContentBlock | IComponentBlocksTestimonials | IComponentBlocksVideo | IComponentGlobalFooter | IComponentSharedBranchLocations | IComponentSharedCards | IComponentSharedContactBlockColumn | IComponentSharedContactColumnLinks | IComponentSharedFooterColumn | IComponentSharedHero | IComponentSharedHeroImage | IComponentSharedHeroVideo | IComponentSharedImageField | IComponentSharedLink | IComponentSharedMapMarker | IComponentSharedMetaSocial | IComponentSharedMotorhomeInfoTab | IComponentSharedPartnerLink | IComponentSharedRichTextColumn | IComponentSharedSeo | IComponentSharedSocialNetworks | IComponentSharedStoryCard | IComponentSharedTab | IComponentSharedTitleAndDescription | ICustomerRadarFeedback | IFaqItem | IGlobal | II18NLocale | IIconCard | IMediaWithContent | IMuxVideoUploaderMuxAsset | IMuxVideoUploaderMuxTextTrack | IPage | IRedirect | ISocialPost | IStory | IStorySubmission | ITestimonial | IUploadFile | IUploadFolder | IUsersPermissionsPermission | IUsersPermissionsRole | IUsersPermissionsUser;

export type IGlobal = {
  __typename?: 'Global';
  bookingURL: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  footer: IComponentGlobalFooter;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<IGlobalRelationResponseCollection>;
  partnerLinks?: Maybe<Array<Maybe<IComponentSharedPartnerLink>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  storySubmissionEmail: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type IGlobalLocalizationsArgs = {
  publicationState?: InputMaybe<IPublicationState>;
};


export type IGlobalPartnerLinksArgs = {
  filters?: InputMaybe<IComponentSharedPartnerLinkFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IGlobalEntity = {
  __typename?: 'GlobalEntity';
  attributes?: Maybe<IGlobal>;
  id?: Maybe<Scalars['ID']>;
};

export type IGlobalEntityResponse = {
  __typename?: 'GlobalEntityResponse';
  data?: Maybe<IGlobalEntity>;
};

export type IGlobalInput = {
  bookingURL?: InputMaybe<Scalars['String']>;
  footer?: InputMaybe<IComponentGlobalFooterInput>;
  partnerLinks?: InputMaybe<Array<InputMaybe<IComponentSharedPartnerLinkInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  storySubmissionEmail?: InputMaybe<Scalars['String']>;
};

export type IGlobalRelationResponseCollection = {
  __typename?: 'GlobalRelationResponseCollection';
  data: Array<IGlobalEntity>;
};

export type II18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type II18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<II18NLocale>;
  id?: Maybe<Scalars['ID']>;
};

export type II18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<II18NLocaleEntity>;
};

export type II18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<II18NLocaleEntity>;
  meta: IResponseCollectionMeta;
};

export type II18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<II18NLocaleFiltersInput>>>;
  code?: InputMaybe<IStringFilterInput>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  name?: InputMaybe<IStringFilterInput>;
  not?: InputMaybe<II18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<II18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
};

export type IIdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contains?: InputMaybe<Scalars['ID']>;
  containsi?: InputMaybe<Scalars['ID']>;
  endsWith?: InputMaybe<Scalars['ID']>;
  eq?: InputMaybe<Scalars['ID']>;
  eqi?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
  ne?: InputMaybe<Scalars['ID']>;
  nei?: InputMaybe<Scalars['ID']>;
  not?: InputMaybe<IIdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']>;
  notContainsi?: InputMaybe<Scalars['ID']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startsWith?: InputMaybe<Scalars['ID']>;
};

export type IIconCard = {
  __typename?: 'IconCard';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  icon?: Maybe<IUploadFileEntityResponse>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<IIconCardRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type IIconCardLocalizationsArgs = {
  filters?: InputMaybe<IIconCardFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  publicationState?: InputMaybe<IPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IIconCardEntity = {
  __typename?: 'IconCardEntity';
  attributes?: Maybe<IIconCard>;
  id?: Maybe<Scalars['ID']>;
};

export type IIconCardEntityResponse = {
  __typename?: 'IconCardEntityResponse';
  data?: Maybe<IIconCardEntity>;
};

export type IIconCardEntityResponseCollection = {
  __typename?: 'IconCardEntityResponseCollection';
  data: Array<IIconCardEntity>;
  meta: IResponseCollectionMeta;
};

export type IIconCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IIconCardFiltersInput>>>;
  content?: InputMaybe<IStringFilterInput>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  locale?: InputMaybe<IStringFilterInput>;
  localizations?: InputMaybe<IIconCardFiltersInput>;
  not?: InputMaybe<IIconCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IIconCardFiltersInput>>>;
  publishedAt?: InputMaybe<IDateTimeFilterInput>;
  title?: InputMaybe<IStringFilterInput>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
};

export type IIconCardInput = {
  content?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type IIconCardRelationResponseCollection = {
  __typename?: 'IconCardRelationResponseCollection';
  data: Array<IIconCardEntity>;
};

export type IIntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  contains?: InputMaybe<Scalars['Int']>;
  containsi?: InputMaybe<Scalars['Int']>;
  endsWith?: InputMaybe<Scalars['Int']>;
  eq?: InputMaybe<Scalars['Int']>;
  eqi?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  nei?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<IIntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']>;
  notContainsi?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  startsWith?: InputMaybe<Scalars['Int']>;
};

export type IJsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  contains?: InputMaybe<Scalars['JSON']>;
  containsi?: InputMaybe<Scalars['JSON']>;
  endsWith?: InputMaybe<Scalars['JSON']>;
  eq?: InputMaybe<Scalars['JSON']>;
  eqi?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nei?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<IJsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']>;
  notContainsi?: InputMaybe<Scalars['JSON']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  startsWith?: InputMaybe<Scalars['JSON']>;
};

export type IMediaWithContent = {
  __typename?: 'MediaWithContent';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<IUploadFileEntityResponse>;
  link?: Maybe<IComponentSharedLink>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<IMediaWithContentRelationResponseCollection>;
  mediaAlignment: IEnum_Mediawithcontent_Mediaalignment;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  video?: Maybe<IMuxVideoUploaderMuxAssetEntityResponse>;
};


export type IMediaWithContentLocalizationsArgs = {
  filters?: InputMaybe<IMediaWithContentFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IMediaWithContentEntity = {
  __typename?: 'MediaWithContentEntity';
  attributes?: Maybe<IMediaWithContent>;
  id?: Maybe<Scalars['ID']>;
};

export type IMediaWithContentEntityResponse = {
  __typename?: 'MediaWithContentEntityResponse';
  data?: Maybe<IMediaWithContentEntity>;
};

export type IMediaWithContentEntityResponseCollection = {
  __typename?: 'MediaWithContentEntityResponseCollection';
  data: Array<IMediaWithContentEntity>;
  meta: IResponseCollectionMeta;
};

export type IMediaWithContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IMediaWithContentFiltersInput>>>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  description?: InputMaybe<IStringFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  link?: InputMaybe<IComponentSharedLinkFiltersInput>;
  locale?: InputMaybe<IStringFilterInput>;
  localizations?: InputMaybe<IMediaWithContentFiltersInput>;
  mediaAlignment?: InputMaybe<IStringFilterInput>;
  not?: InputMaybe<IMediaWithContentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IMediaWithContentFiltersInput>>>;
  title?: InputMaybe<IStringFilterInput>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
  video?: InputMaybe<IMuxVideoUploaderMuxAssetFiltersInput>;
};

export type IMediaWithContentInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['ID']>;
  link?: InputMaybe<IComponentSharedLinkInput>;
  mediaAlignment?: InputMaybe<IEnum_Mediawithcontent_Mediaalignment>;
  title?: InputMaybe<Scalars['String']>;
  video?: InputMaybe<Scalars['ID']>;
};

export type IMediaWithContentRelationResponseCollection = {
  __typename?: 'MediaWithContentRelationResponseCollection';
  data: Array<IMediaWithContentEntity>;
};

export type IMutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<IUsersPermissionsLoginPayload>;
  createAwesomeHelpHelp?: Maybe<IAwesomeHelpHelpEntityResponse>;
  createCard?: Maybe<ICardEntityResponse>;
  createCardCollection?: Maybe<ICardCollectionEntityResponse>;
  createCardCollectionLocalization?: Maybe<ICardCollectionEntityResponse>;
  createCardLocalization?: Maybe<ICardEntityResponse>;
  createCustomerRadarFeedback?: Maybe<ICustomerRadarFeedbackEntityResponse>;
  createFaqItem?: Maybe<IFaqItemEntityResponse>;
  createGlobalLocalization?: Maybe<IGlobalEntityResponse>;
  createIconCard?: Maybe<IIconCardEntityResponse>;
  createIconCardLocalization?: Maybe<IIconCardEntityResponse>;
  createMediaWithContent?: Maybe<IMediaWithContentEntityResponse>;
  createMediaWithContentLocalization?: Maybe<IMediaWithContentEntityResponse>;
  createMuxVideoUploaderMuxAsset?: Maybe<IMuxVideoUploaderMuxAssetEntityResponse>;
  createMuxVideoUploaderMuxTextTrack?: Maybe<IMuxVideoUploaderMuxTextTrackEntityResponse>;
  createPage?: Maybe<IPageEntityResponse>;
  createPageLocalization?: Maybe<IPageEntityResponse>;
  createRedirect?: Maybe<IRedirectEntityResponse>;
  createSocialPost?: Maybe<ISocialPostEntityResponse>;
  createStory?: Maybe<IStoryEntityResponse>;
  createStoryLocalization?: Maybe<IStoryEntityResponse>;
  createStorySubmission?: Maybe<IStorySubmissionEntityResponse>;
  createStorySubmissionLocalization?: Maybe<IStorySubmissionEntityResponse>;
  createTestimonial?: Maybe<ITestimonialEntityResponse>;
  createUploadFile?: Maybe<IUploadFileEntityResponse>;
  createUploadFolder?: Maybe<IUploadFolderEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<IUsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: IUsersPermissionsUserEntityResponse;
  deleteAwesomeHelpHelp?: Maybe<IAwesomeHelpHelpEntityResponse>;
  deleteCard?: Maybe<ICardEntityResponse>;
  deleteCardCollection?: Maybe<ICardCollectionEntityResponse>;
  deleteCustomerRadarFeedback?: Maybe<ICustomerRadarFeedbackEntityResponse>;
  deleteFaqItem?: Maybe<IFaqItemEntityResponse>;
  deleteGlobal?: Maybe<IGlobalEntityResponse>;
  deleteIconCard?: Maybe<IIconCardEntityResponse>;
  deleteMediaWithContent?: Maybe<IMediaWithContentEntityResponse>;
  deleteMuxVideoUploaderMuxAsset?: Maybe<IMuxVideoUploaderMuxAssetEntityResponse>;
  deleteMuxVideoUploaderMuxTextTrack?: Maybe<IMuxVideoUploaderMuxTextTrackEntityResponse>;
  deletePage?: Maybe<IPageEntityResponse>;
  deleteRedirect?: Maybe<IRedirectEntityResponse>;
  deleteSocialPost?: Maybe<ISocialPostEntityResponse>;
  deleteStory?: Maybe<IStoryEntityResponse>;
  deleteStorySubmission?: Maybe<IStorySubmissionEntityResponse>;
  deleteTestimonial?: Maybe<ITestimonialEntityResponse>;
  deleteUploadFile?: Maybe<IUploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<IUploadFolderEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<IUsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: IUsersPermissionsUserEntityResponse;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<IUsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<IUsersPermissionsPasswordPayload>;
  login: IUsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<IUploadFileEntityResponse>>;
  /** Register a user */
  register: IUsersPermissionsLoginPayload;
  removeFile?: Maybe<IUploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<IUsersPermissionsLoginPayload>;
  updateAwesomeHelpHelp?: Maybe<IAwesomeHelpHelpEntityResponse>;
  updateCard?: Maybe<ICardEntityResponse>;
  updateCardCollection?: Maybe<ICardCollectionEntityResponse>;
  updateCustomerRadarFeedback?: Maybe<ICustomerRadarFeedbackEntityResponse>;
  updateFaqItem?: Maybe<IFaqItemEntityResponse>;
  updateFileInfo: IUploadFileEntityResponse;
  updateGlobal?: Maybe<IGlobalEntityResponse>;
  updateIconCard?: Maybe<IIconCardEntityResponse>;
  updateMediaWithContent?: Maybe<IMediaWithContentEntityResponse>;
  updateMuxVideoUploaderMuxAsset?: Maybe<IMuxVideoUploaderMuxAssetEntityResponse>;
  updateMuxVideoUploaderMuxTextTrack?: Maybe<IMuxVideoUploaderMuxTextTrackEntityResponse>;
  updatePage?: Maybe<IPageEntityResponse>;
  updateRedirect?: Maybe<IRedirectEntityResponse>;
  updateSocialPost?: Maybe<ISocialPostEntityResponse>;
  updateStory?: Maybe<IStoryEntityResponse>;
  updateStorySubmission?: Maybe<IStorySubmissionEntityResponse>;
  updateTestimonial?: Maybe<ITestimonialEntityResponse>;
  updateUploadFile?: Maybe<IUploadFileEntityResponse>;
  updateUploadFolder?: Maybe<IUploadFolderEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<IUsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: IUsersPermissionsUserEntityResponse;
  upload: IUploadFileEntityResponse;
};


export type IMutationChangePasswordArgs = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type IMutationCreateAwesomeHelpHelpArgs = {
  data: IAwesomeHelpHelpInput;
};


export type IMutationCreateCardArgs = {
  data: ICardInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationCreateCardCollectionArgs = {
  data: ICardCollectionInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationCreateCardCollectionLocalizationArgs = {
  data?: InputMaybe<ICardCollectionInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationCreateCardLocalizationArgs = {
  data?: InputMaybe<ICardInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationCreateCustomerRadarFeedbackArgs = {
  data: ICustomerRadarFeedbackInput;
};


export type IMutationCreateFaqItemArgs = {
  data: IFaqItemInput;
};


export type IMutationCreateGlobalLocalizationArgs = {
  data?: InputMaybe<IGlobalInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationCreateIconCardArgs = {
  data: IIconCardInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationCreateIconCardLocalizationArgs = {
  data?: InputMaybe<IIconCardInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationCreateMediaWithContentArgs = {
  data: IMediaWithContentInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationCreateMediaWithContentLocalizationArgs = {
  data?: InputMaybe<IMediaWithContentInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationCreateMuxVideoUploaderMuxAssetArgs = {
  data: IMuxVideoUploaderMuxAssetInput;
};


export type IMutationCreateMuxVideoUploaderMuxTextTrackArgs = {
  data: IMuxVideoUploaderMuxTextTrackInput;
};


export type IMutationCreatePageArgs = {
  data: IPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationCreatePageLocalizationArgs = {
  data?: InputMaybe<IPageInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationCreateRedirectArgs = {
  data: IRedirectInput;
};


export type IMutationCreateSocialPostArgs = {
  data: ISocialPostInput;
};


export type IMutationCreateStoryArgs = {
  data: IStoryInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationCreateStoryLocalizationArgs = {
  data?: InputMaybe<IStoryInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationCreateStorySubmissionArgs = {
  data: IStorySubmissionInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationCreateStorySubmissionLocalizationArgs = {
  data?: InputMaybe<IStorySubmissionInput>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationCreateTestimonialArgs = {
  data: ITestimonialInput;
};


export type IMutationCreateUploadFileArgs = {
  data: IUploadFileInput;
};


export type IMutationCreateUploadFolderArgs = {
  data: IUploadFolderInput;
};


export type IMutationCreateUsersPermissionsRoleArgs = {
  data: IUsersPermissionsRoleInput;
};


export type IMutationCreateUsersPermissionsUserArgs = {
  data: IUsersPermissionsUserInput;
};


export type IMutationDeleteAwesomeHelpHelpArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteCardArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationDeleteCardCollectionArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationDeleteCustomerRadarFeedbackArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteFaqItemArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteGlobalArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationDeleteIconCardArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationDeleteMediaWithContentArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationDeleteMuxVideoUploaderMuxAssetArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteMuxVideoUploaderMuxTextTrackArgs = {
  id: Scalars['ID'];
};


export type IMutationDeletePageArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationDeleteRedirectArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteSocialPostArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteStoryArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationDeleteStorySubmissionArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationDeleteTestimonialArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteUploadFileArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteUploadFolderArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID'];
};


export type IMutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type IMutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type IMutationLoginArgs = {
  input: IUsersPermissionsLoginInput;
};


export type IMutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  files: Array<InputMaybe<Scalars['Upload']>>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
};


export type IMutationRegisterArgs = {
  input: IUsersPermissionsRegisterInput;
};


export type IMutationRemoveFileArgs = {
  id: Scalars['ID'];
};


export type IMutationResetPasswordArgs = {
  code: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type IMutationUpdateAwesomeHelpHelpArgs = {
  data: IAwesomeHelpHelpInput;
  id: Scalars['ID'];
};


export type IMutationUpdateCardArgs = {
  data: ICardInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationUpdateCardCollectionArgs = {
  data: ICardCollectionInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationUpdateCustomerRadarFeedbackArgs = {
  data: ICustomerRadarFeedbackInput;
  id: Scalars['ID'];
};


export type IMutationUpdateFaqItemArgs = {
  data: IFaqItemInput;
  id: Scalars['ID'];
};


export type IMutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info?: InputMaybe<IFileInfoInput>;
};


export type IMutationUpdateGlobalArgs = {
  data: IGlobalInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationUpdateIconCardArgs = {
  data: IIconCardInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationUpdateMediaWithContentArgs = {
  data: IMediaWithContentInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationUpdateMuxVideoUploaderMuxAssetArgs = {
  data: IMuxVideoUploaderMuxAssetInput;
  id: Scalars['ID'];
};


export type IMutationUpdateMuxVideoUploaderMuxTextTrackArgs = {
  data: IMuxVideoUploaderMuxTextTrackInput;
  id: Scalars['ID'];
};


export type IMutationUpdatePageArgs = {
  data: IPageInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationUpdateRedirectArgs = {
  data: IRedirectInput;
  id: Scalars['ID'];
};


export type IMutationUpdateSocialPostArgs = {
  data: ISocialPostInput;
  id: Scalars['ID'];
};


export type IMutationUpdateStoryArgs = {
  data: IStoryInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationUpdateStorySubmissionArgs = {
  data: IStorySubmissionInput;
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IMutationUpdateTestimonialArgs = {
  data: ITestimonialInput;
  id: Scalars['ID'];
};


export type IMutationUpdateUploadFileArgs = {
  data: IUploadFileInput;
  id: Scalars['ID'];
};


export type IMutationUpdateUploadFolderArgs = {
  data: IUploadFolderInput;
  id: Scalars['ID'];
};


export type IMutationUpdateUsersPermissionsRoleArgs = {
  data: IUsersPermissionsRoleInput;
  id: Scalars['ID'];
};


export type IMutationUpdateUsersPermissionsUserArgs = {
  data: IUsersPermissionsUserInput;
  id: Scalars['ID'];
};


export type IMutationUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  info?: InputMaybe<IFileInfoInput>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
};

export type IMuxVideoUploaderMuxAsset = {
  __typename?: 'MuxVideoUploaderMuxAsset';
  aspect_ratio?: Maybe<Scalars['String']>;
  asset_id?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Float']>;
  error_message?: Maybe<Scalars['String']>;
  isReady?: Maybe<Scalars['Boolean']>;
  playback_id?: Maybe<Scalars['String']>;
  thumbnailTime?: Maybe<Scalars['Float']>;
  thumbnail_fallback_image?: Maybe<IUploadFileEntityResponse>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  upload_id?: Maybe<Scalars['String']>;
};

export type IMuxVideoUploaderMuxAssetEntity = {
  __typename?: 'MuxVideoUploaderMuxAssetEntity';
  attributes?: Maybe<IMuxVideoUploaderMuxAsset>;
  id?: Maybe<Scalars['ID']>;
};

export type IMuxVideoUploaderMuxAssetEntityResponse = {
  __typename?: 'MuxVideoUploaderMuxAssetEntityResponse';
  data?: Maybe<IMuxVideoUploaderMuxAssetEntity>;
};

export type IMuxVideoUploaderMuxAssetEntityResponseCollection = {
  __typename?: 'MuxVideoUploaderMuxAssetEntityResponseCollection';
  data: Array<IMuxVideoUploaderMuxAssetEntity>;
  meta: IResponseCollectionMeta;
};

export type IMuxVideoUploaderMuxAssetFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IMuxVideoUploaderMuxAssetFiltersInput>>>;
  aspect_ratio?: InputMaybe<IStringFilterInput>;
  asset_id?: InputMaybe<IStringFilterInput>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  duration?: InputMaybe<IFloatFilterInput>;
  error_message?: InputMaybe<IStringFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  isReady?: InputMaybe<IBooleanFilterInput>;
  not?: InputMaybe<IMuxVideoUploaderMuxAssetFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IMuxVideoUploaderMuxAssetFiltersInput>>>;
  playback_id?: InputMaybe<IStringFilterInput>;
  thumbnailTime?: InputMaybe<IFloatFilterInput>;
  title?: InputMaybe<IStringFilterInput>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
  upload_id?: InputMaybe<IStringFilterInput>;
};

export type IMuxVideoUploaderMuxAssetInput = {
  aspect_ratio?: InputMaybe<Scalars['String']>;
  asset_id?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Float']>;
  error_message?: InputMaybe<Scalars['String']>;
  isReady?: InputMaybe<Scalars['Boolean']>;
  playback_id?: InputMaybe<Scalars['String']>;
  thumbnailTime?: InputMaybe<Scalars['Float']>;
  thumbnail_fallback_image?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  upload_id?: InputMaybe<Scalars['String']>;
};

export type IMuxVideoUploaderMuxTextTrack = {
  __typename?: 'MuxVideoUploaderMuxTextTrack';
  closed_captions: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  file: Scalars['JSON'];
  language_code: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IMuxVideoUploaderMuxTextTrackEntity = {
  __typename?: 'MuxVideoUploaderMuxTextTrackEntity';
  attributes?: Maybe<IMuxVideoUploaderMuxTextTrack>;
  id?: Maybe<Scalars['ID']>;
};

export type IMuxVideoUploaderMuxTextTrackEntityResponse = {
  __typename?: 'MuxVideoUploaderMuxTextTrackEntityResponse';
  data?: Maybe<IMuxVideoUploaderMuxTextTrackEntity>;
};

export type IMuxVideoUploaderMuxTextTrackEntityResponseCollection = {
  __typename?: 'MuxVideoUploaderMuxTextTrackEntityResponseCollection';
  data: Array<IMuxVideoUploaderMuxTextTrackEntity>;
  meta: IResponseCollectionMeta;
};

export type IMuxVideoUploaderMuxTextTrackFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IMuxVideoUploaderMuxTextTrackFiltersInput>>>;
  closed_captions?: InputMaybe<IBooleanFilterInput>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  file?: InputMaybe<IJsonFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  language_code?: InputMaybe<IStringFilterInput>;
  name?: InputMaybe<IStringFilterInput>;
  not?: InputMaybe<IMuxVideoUploaderMuxTextTrackFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IMuxVideoUploaderMuxTextTrackFiltersInput>>>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
};

export type IMuxVideoUploaderMuxTextTrackInput = {
  closed_captions?: InputMaybe<Scalars['Boolean']>;
  file?: InputMaybe<Scalars['JSON']>;
  language_code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type INavigationItem = {
  __typename?: 'NavigationItem';
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  externalPath?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  items?: Maybe<Array<Maybe<INavigationItem>>>;
  master?: Maybe<Scalars['Int']>;
  menuAttached: Scalars['Boolean'];
  order: Scalars['Int'];
  parent?: Maybe<INavigationItem>;
  path?: Maybe<Scalars['String']>;
  related?: Maybe<INavigationItemRelatedData>;
  title: Scalars['String'];
  type: Scalars['String'];
  uiRouterKey: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['String']>;
};

export type INavigationItemRelated = IPage | IStory;

export type INavigationItemRelatedData = {
  __typename?: 'NavigationItemRelatedData';
  attributes?: Maybe<INavigationItemRelated>;
  id: Scalars['Int'];
};

export enum INavigationRenderType {
  Flat = 'FLAT',
  Rfr = 'RFR',
  Tree = 'TREE'
}

export type IPage = {
  __typename?: 'Page';
  blocks?: Maybe<Array<Maybe<IPageBlocksDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hero?: Maybe<IComponentSharedHero>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<IPageRelationResponseCollection>;
  parentPage?: Maybe<IPageEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  seo: IComponentSharedSeo;
  showRegionPopup?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type IPageLocalizationsArgs = {
  filters?: InputMaybe<IPageFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  publicationState?: InputMaybe<IPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IPageBlocksDynamicZone = IComponentBlocksAltContent | IComponentBlocksCardsBlock | IComponentBlocksCarouselBlock | IComponentBlocksCarouselStories | IComponentBlocksContacts | IComponentBlocksCustomerRadarFeedbackBlock | IComponentBlocksDealsBlock | IComponentBlocksEmbedHtml | IComponentBlocksEnquiryForm | IComponentBlocksFaq | IComponentBlocksGallery | IComponentBlocksGalleryCarousel | IComponentBlocksIconCardBlock | IComponentBlocksMap | IComponentBlocksMotorhomeDetails | IComponentBlocksMotorhomeInfoTabs | IComponentBlocksRichText | IComponentBlocksRichTextColumns | IComponentBlocksSocialMedia | IComponentBlocksStarStoryForm | IComponentBlocksStoryCardGrid | IComponentBlocksTabContentBlock | IComponentBlocksTestimonials | IComponentBlocksVideo | IError;

export type IPageEntity = {
  __typename?: 'PageEntity';
  attributes?: Maybe<IPage>;
  id?: Maybe<Scalars['ID']>;
};

export type IPageEntityResponse = {
  __typename?: 'PageEntityResponse';
  data?: Maybe<IPageEntity>;
};

export type IPageEntityResponseCollection = {
  __typename?: 'PageEntityResponseCollection';
  data: Array<IPageEntity>;
  meta: IResponseCollectionMeta;
};

export type IPageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IPageFiltersInput>>>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  hero?: InputMaybe<IComponentSharedHeroFiltersInput>;
  id?: InputMaybe<IIdFilterInput>;
  locale?: InputMaybe<IStringFilterInput>;
  localizations?: InputMaybe<IPageFiltersInput>;
  not?: InputMaybe<IPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IPageFiltersInput>>>;
  parentPage?: InputMaybe<IPageFiltersInput>;
  publishedAt?: InputMaybe<IDateTimeFilterInput>;
  seo?: InputMaybe<IComponentSharedSeoFiltersInput>;
  showRegionPopup?: InputMaybe<IBooleanFilterInput>;
  slug?: InputMaybe<IStringFilterInput>;
  title?: InputMaybe<IStringFilterInput>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
};

export type IPageInput = {
  blocks?: InputMaybe<Array<Scalars['PageBlocksDynamicZoneInput']>>;
  hero?: InputMaybe<IComponentSharedHeroInput>;
  parentPage?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  seo?: InputMaybe<IComponentSharedSeoInput>;
  showRegionPopup?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type IPageRelationResponseCollection = {
  __typename?: 'PageRelationResponseCollection';
  data: Array<IPageEntity>;
};

export type IPagination = {
  __typename?: 'Pagination';
  page: Scalars['Int'];
  pageCount: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Int'];
};

export type IPaginationArg = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
};

export enum IPublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type IQuery = {
  __typename?: 'Query';
  awesomeHelpHelp?: Maybe<IAwesomeHelpHelpEntityResponse>;
  awesomeHelpHelps?: Maybe<IAwesomeHelpHelpEntityResponseCollection>;
  card?: Maybe<ICardEntityResponse>;
  cardCollection?: Maybe<ICardCollectionEntityResponse>;
  cardCollections?: Maybe<ICardCollectionEntityResponseCollection>;
  cards?: Maybe<ICardEntityResponseCollection>;
  customerRadarFeedback?: Maybe<ICustomerRadarFeedbackEntityResponse>;
  customerRadarFeedbacks?: Maybe<ICustomerRadarFeedbackEntityResponseCollection>;
  faqItem?: Maybe<IFaqItemEntityResponse>;
  faqItems?: Maybe<IFaqItemEntityResponseCollection>;
  global?: Maybe<IGlobalEntityResponse>;
  i18NLocale?: Maybe<II18NLocaleEntityResponse>;
  i18NLocales?: Maybe<II18NLocaleEntityResponseCollection>;
  iconCard?: Maybe<IIconCardEntityResponse>;
  iconCards?: Maybe<IIconCardEntityResponseCollection>;
  me?: Maybe<IUsersPermissionsMe>;
  mediaWithContent?: Maybe<IMediaWithContentEntityResponse>;
  mediaWithContents?: Maybe<IMediaWithContentEntityResponseCollection>;
  muxVideoUploaderMuxAsset?: Maybe<IMuxVideoUploaderMuxAssetEntityResponse>;
  muxVideoUploaderMuxAssets?: Maybe<IMuxVideoUploaderMuxAssetEntityResponseCollection>;
  muxVideoUploaderMuxTextTrack?: Maybe<IMuxVideoUploaderMuxTextTrackEntityResponse>;
  muxVideoUploaderMuxTextTracks?: Maybe<IMuxVideoUploaderMuxTextTrackEntityResponseCollection>;
  page?: Maybe<IPageEntityResponse>;
  pages?: Maybe<IPageEntityResponseCollection>;
  redirect?: Maybe<IRedirectEntityResponse>;
  redirects?: Maybe<IRedirectEntityResponseCollection>;
  renderNavigation: Array<Maybe<INavigationItem>>;
  renderNavigationChild: Array<Maybe<INavigationItem>>;
  socialPost?: Maybe<ISocialPostEntityResponse>;
  socialPosts?: Maybe<ISocialPostEntityResponseCollection>;
  stories?: Maybe<IStoryEntityResponseCollection>;
  story?: Maybe<IStoryEntityResponse>;
  storySubmission?: Maybe<IStorySubmissionEntityResponse>;
  storySubmissions?: Maybe<IStorySubmissionEntityResponseCollection>;
  testimonial?: Maybe<ITestimonialEntityResponse>;
  testimonials?: Maybe<ITestimonialEntityResponseCollection>;
  uploadFile?: Maybe<IUploadFileEntityResponse>;
  uploadFiles?: Maybe<IUploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<IUploadFolderEntityResponse>;
  uploadFolders?: Maybe<IUploadFolderEntityResponseCollection>;
  usersPermissionsRole?: Maybe<IUsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<IUsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<IUsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<IUsersPermissionsUserEntityResponseCollection>;
};


export type IQueryAwesomeHelpHelpArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type IQueryAwesomeHelpHelpsArgs = {
  filters?: InputMaybe<IAwesomeHelpHelpFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryCardArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IQueryCardCollectionArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IQueryCardCollectionsArgs = {
  filters?: InputMaybe<ICardCollectionFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryCardsArgs = {
  filters?: InputMaybe<ICardFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryCustomerRadarFeedbackArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type IQueryCustomerRadarFeedbacksArgs = {
  filters?: InputMaybe<ICustomerRadarFeedbackFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  publicationState?: InputMaybe<IPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryFaqItemArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type IQueryFaqItemsArgs = {
  filters?: InputMaybe<IFaqItemFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryGlobalArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  publicationState?: InputMaybe<IPublicationState>;
};


export type IQueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type IQueryI18NLocalesArgs = {
  filters?: InputMaybe<II18NLocaleFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryIconCardArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IQueryIconCardsArgs = {
  filters?: InputMaybe<IIconCardFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<IPaginationArg>;
  publicationState?: InputMaybe<IPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryMediaWithContentArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IQueryMediaWithContentsArgs = {
  filters?: InputMaybe<IMediaWithContentFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryMuxVideoUploaderMuxAssetArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type IQueryMuxVideoUploaderMuxAssetsArgs = {
  filters?: InputMaybe<IMuxVideoUploaderMuxAssetFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryMuxVideoUploaderMuxTextTrackArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type IQueryMuxVideoUploaderMuxTextTracksArgs = {
  filters?: InputMaybe<IMuxVideoUploaderMuxTextTrackFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryPageArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IQueryPagesArgs = {
  filters?: InputMaybe<IPageFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<IPaginationArg>;
  publicationState?: InputMaybe<IPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryRedirectArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type IQueryRedirectsArgs = {
  filters?: InputMaybe<IRedirectFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryRenderNavigationArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  menuOnly?: InputMaybe<Scalars['Boolean']>;
  navigationIdOrSlug: Scalars['String'];
  path?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<INavigationRenderType>;
};


export type IQueryRenderNavigationChildArgs = {
  childUiKey: Scalars['String'];
  id: Scalars['String'];
  menuOnly?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<INavigationRenderType>;
};


export type IQuerySocialPostArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type IQuerySocialPostsArgs = {
  filters?: InputMaybe<ISocialPostFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryStoriesArgs = {
  filters?: InputMaybe<IStoryFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<IPaginationArg>;
  publicationState?: InputMaybe<IPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryStoryArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IQueryStorySubmissionArgs = {
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
};


export type IQueryStorySubmissionsArgs = {
  filters?: InputMaybe<IStorySubmissionFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']>;
  pagination?: InputMaybe<IPaginationArg>;
  publicationState?: InputMaybe<IPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryTestimonialArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type IQueryTestimonialsArgs = {
  filters?: InputMaybe<ITestimonialFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type IQueryUploadFilesArgs = {
  filters?: InputMaybe<IUploadFileFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type IQueryUploadFoldersArgs = {
  filters?: InputMaybe<IUploadFolderFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type IQueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<IUsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IQueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type IQueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<IUsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IRedirect = {
  __typename?: 'Redirect';
  createdAt?: Maybe<Scalars['DateTime']>;
  pattern: Scalars['String'];
  redirect: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IRedirectEntity = {
  __typename?: 'RedirectEntity';
  attributes?: Maybe<IRedirect>;
  id?: Maybe<Scalars['ID']>;
};

export type IRedirectEntityResponse = {
  __typename?: 'RedirectEntityResponse';
  data?: Maybe<IRedirectEntity>;
};

export type IRedirectEntityResponseCollection = {
  __typename?: 'RedirectEntityResponseCollection';
  data: Array<IRedirectEntity>;
  meta: IResponseCollectionMeta;
};

export type IRedirectFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IRedirectFiltersInput>>>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  not?: InputMaybe<IRedirectFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IRedirectFiltersInput>>>;
  pattern?: InputMaybe<IStringFilterInput>;
  redirect?: InputMaybe<IStringFilterInput>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
};

export type IRedirectInput = {
  pattern?: InputMaybe<Scalars['String']>;
  redirect?: InputMaybe<Scalars['String']>;
};

export type IResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: IPagination;
};

export type ISocialPost = {
  __typename?: 'SocialPost';
  createdAt?: Maybe<Scalars['DateTime']>;
  image?: Maybe<IUploadFileEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
};

export type ISocialPostEntity = {
  __typename?: 'SocialPostEntity';
  attributes?: Maybe<ISocialPost>;
  id?: Maybe<Scalars['ID']>;
};

export type ISocialPostEntityResponse = {
  __typename?: 'SocialPostEntityResponse';
  data?: Maybe<ISocialPostEntity>;
};

export type ISocialPostEntityResponseCollection = {
  __typename?: 'SocialPostEntityResponseCollection';
  data: Array<ISocialPostEntity>;
  meta: IResponseCollectionMeta;
};

export type ISocialPostFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ISocialPostFiltersInput>>>;
  cmsTitle?: InputMaybe<IStringFilterInput>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  not?: InputMaybe<ISocialPostFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ISocialPostFiltersInput>>>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
  url?: InputMaybe<IStringFilterInput>;
};

export type ISocialPostInput = {
  cmsTitle?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['ID']>;
  url?: InputMaybe<Scalars['String']>;
};

export type ISocialPostRelationResponseCollection = {
  __typename?: 'SocialPostRelationResponseCollection';
  data: Array<ISocialPostEntity>;
};

export type IStory = {
  __typename?: 'Story';
  blocks?: Maybe<Array<Maybe<IStoryBlocksDynamicZone>>>;
  cmsTitle: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  hero?: Maybe<IComponentSharedHero>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<IStoryRelationResponseCollection>;
  parentPage?: Maybe<IPageEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  seo: IComponentSharedSeo;
  showRegionPopup?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type IStoryLocalizationsArgs = {
  filters?: InputMaybe<IStoryFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  publicationState?: InputMaybe<IPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IStoryBlocksDynamicZone = IComponentBlocksCardsBlock | IComponentBlocksCarouselBlock | IComponentBlocksCarouselStories | IComponentBlocksContacts | IComponentBlocksDealsBlock | IComponentBlocksFaq | IComponentBlocksGallery | IComponentBlocksGalleryCarousel | IComponentBlocksMap | IComponentBlocksRichText | IComponentBlocksRichTextColumns | IComponentBlocksSocialMedia | IComponentBlocksStoryCardGrid | IComponentBlocksTestimonials | IComponentBlocksVideo | IError;

export type IStoryEntity = {
  __typename?: 'StoryEntity';
  attributes?: Maybe<IStory>;
  id?: Maybe<Scalars['ID']>;
};

export type IStoryEntityResponse = {
  __typename?: 'StoryEntityResponse';
  data?: Maybe<IStoryEntity>;
};

export type IStoryEntityResponseCollection = {
  __typename?: 'StoryEntityResponseCollection';
  data: Array<IStoryEntity>;
  meta: IResponseCollectionMeta;
};

export type IStoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IStoryFiltersInput>>>;
  cmsTitle?: InputMaybe<IStringFilterInput>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  hero?: InputMaybe<IComponentSharedHeroFiltersInput>;
  id?: InputMaybe<IIdFilterInput>;
  locale?: InputMaybe<IStringFilterInput>;
  localizations?: InputMaybe<IStoryFiltersInput>;
  not?: InputMaybe<IStoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IStoryFiltersInput>>>;
  parentPage?: InputMaybe<IPageFiltersInput>;
  publishedAt?: InputMaybe<IDateTimeFilterInput>;
  seo?: InputMaybe<IComponentSharedSeoFiltersInput>;
  showRegionPopup?: InputMaybe<IBooleanFilterInput>;
  slug?: InputMaybe<IStringFilterInput>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
};

export type IStoryInput = {
  blocks?: InputMaybe<Array<Scalars['StoryBlocksDynamicZoneInput']>>;
  cmsTitle?: InputMaybe<Scalars['String']>;
  hero?: InputMaybe<IComponentSharedHeroInput>;
  parentPage?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  seo?: InputMaybe<IComponentSharedSeoInput>;
  showRegionPopup?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type IStoryRelationResponseCollection = {
  __typename?: 'StoryRelationResponseCollection';
  data: Array<IStoryEntity>;
};

export type IStorySubmission = {
  __typename?: 'StorySubmission';
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSON']>;
  images?: Maybe<IUploadFileRelationResponseCollection>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<IStorySubmissionRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type IStorySubmissionImagesArgs = {
  filters?: InputMaybe<IUploadFileFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IStorySubmissionLocalizationsArgs = {
  filters?: InputMaybe<IStorySubmissionFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  publicationState?: InputMaybe<IPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IStorySubmissionEntity = {
  __typename?: 'StorySubmissionEntity';
  attributes?: Maybe<IStorySubmission>;
  id?: Maybe<Scalars['ID']>;
};

export type IStorySubmissionEntityResponse = {
  __typename?: 'StorySubmissionEntityResponse';
  data?: Maybe<IStorySubmissionEntity>;
};

export type IStorySubmissionEntityResponseCollection = {
  __typename?: 'StorySubmissionEntityResponseCollection';
  data: Array<IStorySubmissionEntity>;
  meta: IResponseCollectionMeta;
};

export type IStorySubmissionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IStorySubmissionFiltersInput>>>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  data?: InputMaybe<IJsonFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  locale?: InputMaybe<IStringFilterInput>;
  localizations?: InputMaybe<IStorySubmissionFiltersInput>;
  not?: InputMaybe<IStorySubmissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IStorySubmissionFiltersInput>>>;
  publishedAt?: InputMaybe<IDateTimeFilterInput>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
};

export type IStorySubmissionInput = {
  data?: InputMaybe<Scalars['JSON']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IStorySubmissionRelationResponseCollection = {
  __typename?: 'StorySubmissionRelationResponseCollection';
  data: Array<IStorySubmissionEntity>;
};

export type IStringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  containsi?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  eqi?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nei?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<IStringFilterInput>;
  notContains?: InputMaybe<Scalars['String']>;
  notContainsi?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type ITestimonial = {
  __typename?: 'Testimonial';
  author?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  image?: Maybe<IUploadFileEntityResponse>;
  quote?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ITestimonialEntity = {
  __typename?: 'TestimonialEntity';
  attributes?: Maybe<ITestimonial>;
  id?: Maybe<Scalars['ID']>;
};

export type ITestimonialEntityResponse = {
  __typename?: 'TestimonialEntityResponse';
  data?: Maybe<ITestimonialEntity>;
};

export type ITestimonialEntityResponseCollection = {
  __typename?: 'TestimonialEntityResponseCollection';
  data: Array<ITestimonialEntity>;
  meta: IResponseCollectionMeta;
};

export type ITestimonialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ITestimonialFiltersInput>>>;
  author?: InputMaybe<IStringFilterInput>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  not?: InputMaybe<ITestimonialFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ITestimonialFiltersInput>>>;
  quote?: InputMaybe<IStringFilterInput>;
  rating?: InputMaybe<IFloatFilterInput>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
};

export type ITestimonialInput = {
  author?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['ID']>;
  quote?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['Float']>;
};

export type ITestimonialRelationResponseCollection = {
  __typename?: 'TestimonialRelationResponseCollection';
  data: Array<ITestimonialEntity>;
};

export type IUploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ext?: Maybe<Scalars['String']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  mime: Scalars['String'];
  name: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<IGenericMorph>>>;
  size: Scalars['Float'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type IUploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<IUploadFile>;
  id?: Maybe<Scalars['ID']>;
};

export type IUploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<IUploadFileEntity>;
};

export type IUploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<IUploadFileEntity>;
  meta: IResponseCollectionMeta;
};

export type IUploadFileFiltersInput = {
  alternativeText?: InputMaybe<IStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<IUploadFileFiltersInput>>>;
  caption?: InputMaybe<IStringFilterInput>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  ext?: InputMaybe<IStringFilterInput>;
  folder?: InputMaybe<IUploadFolderFiltersInput>;
  folderPath?: InputMaybe<IStringFilterInput>;
  formats?: InputMaybe<IJsonFilterInput>;
  hash?: InputMaybe<IStringFilterInput>;
  height?: InputMaybe<IIntFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  mime?: InputMaybe<IStringFilterInput>;
  name?: InputMaybe<IStringFilterInput>;
  not?: InputMaybe<IUploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IUploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<IStringFilterInput>;
  provider?: InputMaybe<IStringFilterInput>;
  provider_metadata?: InputMaybe<IJsonFilterInput>;
  size?: InputMaybe<IFloatFilterInput>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
  url?: InputMaybe<IStringFilterInput>;
  width?: InputMaybe<IIntFilterInput>;
};

export type IUploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  ext?: InputMaybe<Scalars['String']>;
  folder?: InputMaybe<Scalars['ID']>;
  folderPath?: InputMaybe<Scalars['String']>;
  formats?: InputMaybe<Scalars['JSON']>;
  hash?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  mime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  previewUrl?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  provider_metadata?: InputMaybe<Scalars['JSON']>;
  size?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type IUploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<IUploadFileEntity>;
};

export type IUploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<IUploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  files?: Maybe<IUploadFileRelationResponseCollection>;
  name: Scalars['String'];
  parent?: Maybe<IUploadFolderEntityResponse>;
  path: Scalars['String'];
  pathId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type IUploadFolderChildrenArgs = {
  filters?: InputMaybe<IUploadFolderFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IUploadFolderFilesArgs = {
  filters?: InputMaybe<IUploadFileFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IUploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<IUploadFolder>;
  id?: Maybe<Scalars['ID']>;
};

export type IUploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<IUploadFolderEntity>;
};

export type IUploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<IUploadFolderEntity>;
  meta: IResponseCollectionMeta;
};

export type IUploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IUploadFolderFiltersInput>>>;
  children?: InputMaybe<IUploadFolderFiltersInput>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  files?: InputMaybe<IUploadFileFiltersInput>;
  id?: InputMaybe<IIdFilterInput>;
  name?: InputMaybe<IStringFilterInput>;
  not?: InputMaybe<IUploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IUploadFolderFiltersInput>>>;
  parent?: InputMaybe<IUploadFolderFiltersInput>;
  path?: InputMaybe<IStringFilterInput>;
  pathId?: InputMaybe<IIntFilterInput>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
};

export type IUploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
  pathId?: InputMaybe<Scalars['Int']>;
};

export type IUploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<IUploadFolderEntity>;
};

export type IUsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean'];
};

export type IUsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean'];
};

export type IUsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Scalars['String'];
};

export type IUsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: IUsersPermissionsMe;
};

export type IUsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  role?: Maybe<IUsersPermissionsMeRole>;
  username: Scalars['String'];
};

export type IUsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type IUsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type IUsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  role?: Maybe<IUsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IUsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<IUsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']>;
};

export type IUsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<IStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<IUsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  not?: InputMaybe<IUsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IUsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<IUsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
};

export type IUsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<IUsersPermissionsPermissionEntity>;
};

export type IUsersPermissionsRegisterInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type IUsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  permissions?: Maybe<IUsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<IUsersPermissionsUserRelationResponseCollection>;
};


export type IUsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<IUsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type IUsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<IUsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<IPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IUsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<IUsersPermissionsRole>;
  id?: Maybe<Scalars['ID']>;
};

export type IUsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<IUsersPermissionsRoleEntity>;
};

export type IUsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<IUsersPermissionsRoleEntity>;
  meta: IResponseCollectionMeta;
};

export type IUsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IUsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  description?: InputMaybe<IStringFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  name?: InputMaybe<IStringFilterInput>;
  not?: InputMaybe<IUsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IUsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<IUsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<IStringFilterInput>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
  users?: InputMaybe<IUsersPermissionsUserFiltersInput>;
};

export type IUsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  type?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type IUsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean'];
};

export type IUsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  role?: Maybe<IUsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
};

export type IUsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<IUsersPermissionsUser>;
  id?: Maybe<Scalars['ID']>;
};

export type IUsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<IUsersPermissionsUserEntity>;
};

export type IUsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<IUsersPermissionsUserEntity>;
  meta: IResponseCollectionMeta;
};

export type IUsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<IUsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<IBooleanFilterInput>;
  confirmationToken?: InputMaybe<IStringFilterInput>;
  confirmed?: InputMaybe<IBooleanFilterInput>;
  createdAt?: InputMaybe<IDateTimeFilterInput>;
  email?: InputMaybe<IStringFilterInput>;
  id?: InputMaybe<IIdFilterInput>;
  not?: InputMaybe<IUsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<IUsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<IStringFilterInput>;
  provider?: InputMaybe<IStringFilterInput>;
  resetPasswordToken?: InputMaybe<IStringFilterInput>;
  role?: InputMaybe<IUsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<IDateTimeFilterInput>;
  username?: InputMaybe<IStringFilterInput>;
};

export type IUsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  confirmationToken?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
};

export type IUsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<IUsersPermissionsUserEntity>;
};

export const CustomerRadarFeedbackFragmentFragmentDoc = gql`
    fragment customerRadarFeedbackFragment on CustomerRadarFeedback {
  author
  country
  countryOfOrigin
  publishedAt
  date
  fleetCategory
  quote
  rating
}
    `;
export const CustomerRadarFeedbackEntityFragmentFragmentDoc = gql`
    fragment customerRadarFeedbackEntityFragment on CustomerRadarFeedbackEntity {
  attributes {
    ...customerRadarFeedbackFragment
  }
}
    ${CustomerRadarFeedbackFragmentFragmentDoc}`;
export const CustomerRadarFeedbackItemsFragmentFragmentDoc = gql`
    fragment customerRadarFeedbackItemsFragment on CustomerRadarFeedbackEntityResponseCollection {
  data {
    ...customerRadarFeedbackEntityFragment
  }
}
    ${CustomerRadarFeedbackEntityFragmentFragmentDoc}`;
export const ImageAttributesFragmentFragmentDoc = gql`
    fragment imageAttributesFragment on UploadFile {
  alternativeText
  caption
  createdAt
  ext
  formats
  hash
  height
  mime
  name
  previewUrl
  provider
  provider_metadata
  size
  updatedAt
  url
  width
}
    `;
export const ImageDataFragmentFragmentDoc = gql`
    fragment imageDataFragment on UploadFileEntity {
  attributes {
    ...imageAttributesFragment
  }
}
    ${ImageAttributesFragmentFragmentDoc}`;
export const ImageFragmentFragmentDoc = gql`
    fragment imageFragment on UploadFileEntityResponse {
  data {
    ...imageDataFragment
  }
}
    ${ImageDataFragmentFragmentDoc}`;
export const MetaSocialFragmentFragmentDoc = gql`
    fragment metaSocialFragment on ComponentSharedMetaSocial {
  socialNetwork
  title
  description
  image {
    ...imageFragment
  }
}
    ${ImageFragmentFragmentDoc}`;
export const SeoFragmentFragmentDoc = gql`
    fragment seoFragment on ComponentSharedSeo {
  metaTitle
  metaDescription
  metaImage {
    ...imageFragment
  }
  keywords
  canonicalURL
  metaRobots
  metaSocial {
    ...metaSocialFragment
  }
  customLdJson
}
    ${ImageFragmentFragmentDoc}
${MetaSocialFragmentFragmentDoc}`;
export const HeroImageFragmentFragmentDoc = gql`
    fragment heroImageFragment on ComponentSharedHeroImage {
  variant
  descriptionHighlight
  image {
    ...imageFragment
  }
}
    ${ImageFragmentFragmentDoc}`;
export const MuxVideoUploaderAssetFragmentFragmentDoc = gql`
    fragment muxVideoUploaderAssetFragment on MuxVideoUploaderMuxAsset {
  aspect_ratio
  asset_id
  createdAt
  duration
  error_message
  isReady
  playback_id
  title
  updatedAt
  upload_id
  thumbnailTime
}
    `;
export const MuxVideoUploaderFragmentFragmentDoc = gql`
    fragment muxVideoUploaderFragment on MuxVideoUploaderMuxAssetEntity {
  attributes {
    ...muxVideoUploaderAssetFragment
  }
}
    ${MuxVideoUploaderAssetFragmentFragmentDoc}`;
export const MuxAssetFragmentFragmentDoc = gql`
    fragment muxAssetFragment on MuxVideoUploaderMuxAssetEntityResponse {
  data {
    ...muxVideoUploaderFragment
  }
}
    ${MuxVideoUploaderFragmentFragmentDoc}`;
export const PageFragmentParentAndSlugFragmentDoc = gql`
    fragment PageFragmentParentAndSlug on PageEntity {
  id
  attributes {
    __typename
    title
    slug
    locale
    parentPage {
      data {
        attributes {
          title
          slug
          parentPage {
            data {
              attributes {
                title
                slug
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const StoryFragmentParentAndSlugFragmentDoc = gql`
    fragment StoryFragmentParentAndSlug on StoryEntity {
  id
  attributes {
    __typename
    cmsTitle
    slug
    locale
    parentPage {
      data {
        attributes {
          title
          slug
          parentPage {
            data {
              attributes {
                title
                slug
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const LinkFragmentFragmentDoc = gql`
    fragment linkFragment on ComponentSharedLink {
  id
  label
  linkToExternalPage
  linkToPage {
    data {
      ...PageFragmentParentAndSlug
    }
  }
  linkToStory {
    data {
      ...StoryFragmentParentAndSlug
    }
  }
}
    ${PageFragmentParentAndSlugFragmentDoc}
${StoryFragmentParentAndSlugFragmentDoc}`;
export const HeroVideoFragmentFragmentDoc = gql`
    fragment heroVideoFragment on ComponentSharedHeroVideo {
  eyebrowText
  backgroundVideo {
    ...muxAssetFragment
  }
  fullVideo {
    ...muxAssetFragment
  }
  mobileSecondaryCta {
    ...linkFragment
  }
}
    ${MuxAssetFragmentFragmentDoc}
${LinkFragmentFragmentDoc}`;
export const HeroFragmentFragmentDoc = gql`
    fragment heroFragment on ComponentSharedHero {
  title
  description
  image {
    ...heroImageFragment
  }
  video {
    ...heroVideoFragment
  }
  showBookingBar
  showBreadcrumbs
  bookingBarText
}
    ${HeroImageFragmentFragmentDoc}
${HeroVideoFragmentFragmentDoc}`;
export const TitleDescriptionFragmentFragmentDoc = gql`
    fragment titleDescriptionFragment on ComponentSharedTitleAndDescription {
  id
  eyebrow
  title
  headingLevel
  description
  leftAligned
  showSocialMediaButtons
  button {
    ...linkFragment
  }
}
    ${LinkFragmentFragmentDoc}`;
export const MediaWithContentFragmentFragmentDoc = gql`
    fragment mediaWithContentFragment on MediaWithContentRelationResponseCollection {
  __typename
  data {
    __typename
    id
    attributes {
      title
      description
      link {
        ...linkFragment
      }
      image {
        data {
          attributes {
            url
            alternativeText
          }
        }
      }
      video {
        ...muxAssetFragment
      }
      mediaAlignment
    }
  }
}
    ${LinkFragmentFragmentDoc}
${MuxAssetFragmentFragmentDoc}`;
export const AlternatingMediaWithContentBlockFragmentFragmentDoc = gql`
    fragment AlternatingMediaWithContentBlockFragment on ComponentBlocksAltContent {
  titleDescription {
    ...titleDescriptionFragment
  }
  mediaWithContent {
    ...mediaWithContentFragment
  }
  backgroundColour
  tightPaddingBelow
}
    ${TitleDescriptionFragmentFragmentDoc}
${MediaWithContentFragmentFragmentDoc}`;
export const BlocksRichTextFragmentFragmentDoc = gql`
    fragment BlocksRichTextFragment on ComponentBlocksRichText {
  richText
  tightPaddingBelow
}
    `;
export const CardFragmentDoc = gql`
    fragment Card on Card {
  Card {
    id
    backgroundColour
    tintImage
    eyebrowText
    title
    description
    image {
      data {
        attributes {
          url
          alternativeText
        }
      }
    }
    video {
      ...muxAssetFragment
    }
    link {
      ...linkFragment
    }
  }
}
    ${MuxAssetFragmentFragmentDoc}
${LinkFragmentFragmentDoc}`;
export const CardCollectionFragmentDoc = gql`
    fragment CardCollection on CardCollectionRelationResponseCollection {
  __typename
  data {
    __typename
    id
    attributes {
      reverseOrderOnMobile
      cards {
        data {
          id
          attributes {
            ...Card
          }
        }
      }
    }
  }
}
    ${CardFragmentDoc}`;
export const CardsBlockFragmentFragmentDoc = gql`
    fragment CardsBlockFragment on ComponentBlocksCardsBlock {
  titleDescription {
    ...titleDescriptionFragment
  }
  card_collections {
    ...CardCollection
  }
  tightPaddingBelow
}
    ${TitleDescriptionFragmentFragmentDoc}
${CardCollectionFragmentDoc}`;
export const CarouselBlockFragmentFragmentDoc = gql`
    fragment CarouselBlockFragment on ComponentBlocksCarouselBlock {
  titleDescription {
    ...titleDescriptionFragment
  }
  slidesPerView
  cards {
    data {
      id
      attributes {
        ...Card
      }
    }
  }
  tightPaddingBelow
}
    ${TitleDescriptionFragmentFragmentDoc}
${CardFragmentDoc}`;
export const CarouselStoriesFragmentFragmentDoc = gql`
    fragment CarouselStoriesFragment on ComponentBlocksCarouselStories {
  titleDescription {
    ...titleDescriptionFragment
  }
  stories {
    data {
      id
      attributes {
        slug
        parentPage {
          data {
            attributes {
              slug
              parentPage {
                data {
                  attributes {
                    slug
                  }
                }
              }
            }
          }
        }
        hero {
          ...heroFragment
        }
      }
    }
  }
  tightPaddingBelow
  variant
}
    ${TitleDescriptionFragmentFragmentDoc}
${HeroFragmentFragmentDoc}`;
export const ContactLinksFragmentDoc = gql`
    fragment ContactLinks on ComponentSharedContactColumnLinks {
  title
  link {
    ...linkFragment
  }
}
    ${LinkFragmentFragmentDoc}`;
export const ContactColumnsFragmentDoc = gql`
    fragment ContactColumns on ComponentSharedContactBlockColumn {
  title
  links {
    ...ContactLinks
  }
}
    ${ContactLinksFragmentDoc}`;
export const ContactsBlockFragmentFragmentDoc = gql`
    fragment ContactsBlockFragment on ComponentBlocksContacts {
  titleDescription {
    ...titleDescriptionFragment
  }
  columns {
    ...ContactColumns
  }
  tightPaddingBelow
}
    ${TitleDescriptionFragmentFragmentDoc}
${ContactColumnsFragmentDoc}`;
export const CustomerRadarBlockFragmentFragmentDoc = gql`
    fragment CustomerRadarBlockFragment on ComponentBlocksCustomerRadarFeedbackBlock {
  titleDescription {
    ...titleDescriptionFragment
  }
  tightPaddingBelow
}
    ${TitleDescriptionFragmentFragmentDoc}`;
export const EmbedHtmlFragmentFragmentDoc = gql`
    fragment EmbedHtmlFragment on ComponentBlocksEmbedHtml {
  id
  __typename
  titleDescription {
    ...titleDescriptionFragment
  }
  tightPaddingBelow
  embedCode
}
    ${TitleDescriptionFragmentFragmentDoc}`;
export const EnquiryFormFragmentFragmentDoc = gql`
    fragment EnquiryFormFragment on ComponentBlocksEnquiryForm {
  titleDescription {
    ...titleDescriptionFragment
  }
  tightPaddingBelow
}
    ${TitleDescriptionFragmentFragmentDoc}`;
export const DealsBlockFragmentFragmentDoc = gql`
    fragment DealsBlockFragment on ComponentBlocksDealsBlock {
  titleDescription {
    ...titleDescriptionFragment
  }
  tightPaddingBelow
}
    ${TitleDescriptionFragmentFragmentDoc}`;
export const FaqItemFragmentFragmentDoc = gql`
    fragment faqItemFragment on FaqItem {
  answer
  createdAt
  question
  updatedAt
}
    `;
export const FaqItemEntityFragmentFragmentDoc = gql`
    fragment faqItemEntityFragment on FaqItemEntity {
  attributes {
    ...faqItemFragment
  }
}
    ${FaqItemFragmentFragmentDoc}`;
export const FaqItemsFragmentFragmentDoc = gql`
    fragment faqItemsFragment on FaqItemRelationResponseCollection {
  data {
    ...faqItemEntityFragment
  }
}
    ${FaqItemEntityFragmentFragmentDoc}`;
export const FaqFragmentFragmentDoc = gql`
    fragment FaqFragment on ComponentBlocksFaq {
  titleDescription {
    ...titleDescriptionFragment
  }
  faqs {
    ...faqItemsFragment
  }
  ctaDescription
  ctaButton {
    ...linkFragment
  }
  tightPaddingBelow
}
    ${TitleDescriptionFragmentFragmentDoc}
${FaqItemsFragmentFragmentDoc}
${LinkFragmentFragmentDoc}`;
export const ImageCollectionFragmentFragmentDoc = gql`
    fragment imageCollectionFragment on UploadFileRelationResponseCollection {
  data {
    ...imageDataFragment
  }
}
    ${ImageDataFragmentFragmentDoc}`;
export const GalleryCarouselFragmentFragmentDoc = gql`
    fragment GalleryCarouselFragment on ComponentBlocksGalleryCarousel {
  eyebrowTitle
  galleryCarouselImages {
    ...imageCollectionFragment
  }
  tightPaddingBelow
}
    ${ImageCollectionFragmentFragmentDoc}`;
export const ImageFieldFragmentDoc = gql`
    fragment imageField on ComponentSharedImageField {
  image {
    ...imageFragment
  }
}
    ${ImageFragmentFragmentDoc}`;
export const GalleryFragmentFragmentDoc = gql`
    fragment GalleryFragment on ComponentBlocksGallery {
  galleryImages {
    ...imageField
  }
  tightPaddingBelow
}
    ${ImageFieldFragmentDoc}`;
export const MapMarkerFragmentFragmentDoc = gql`
    fragment MapMarkerFragment on ComponentSharedMapMarker {
  location
}
    `;
export const BranchLocationsFragmentDoc = gql`
    fragment BranchLocations on ComponentSharedBranchLocations {
  branchLocations
}
    `;
export const MapsFragmentFragmentDoc = gql`
    fragment MapsFragment on ComponentBlocksMap {
  customMarkers {
    ...MapMarkerFragment
  }
  branchLocations {
    ...BranchLocations
  }
  tightPaddingBelow
}
    ${MapMarkerFragmentFragmentDoc}
${BranchLocationsFragmentDoc}`;
export const MotorhomeDetailsFragmentFragmentDoc = gql`
    fragment MotorhomeDetailsFragment on ComponentBlocksMotorhomeDetails {
  fleet
  id
  tightPaddingBelow
}
    `;
export const InfoTabFragmentFragmentDoc = gql`
    fragment infoTabFragment on ComponentSharedMotorhomeInfoTab {
  highlight
}
    `;
export const MotorhomeInfoTabsFragmentDoc = gql`
    fragment MotorhomeInfoTabs on ComponentBlocksMotorhomeInfoTabs {
  infoTabs {
    ...infoTabFragment
  }
  tightPaddingBelow
}
    ${InfoTabFragmentFragmentDoc}`;
export const RichTextColumnFragmentDoc = gql`
    fragment RichTextColumn on ComponentSharedRichTextColumn {
  richText
}
    `;
export const RichTextColumnBlockFragmentDoc = gql`
    fragment RichTextColumnBlock on ComponentBlocksRichTextColumns {
  richTextColumns {
    ...RichTextColumn
  }
  titleDescription {
    ...titleDescriptionFragment
  }
  addBackgroundColour
  tightPaddingBelow
}
    ${RichTextColumnFragmentDoc}
${TitleDescriptionFragmentFragmentDoc}`;
export const SocialPostFragmentFragmentDoc = gql`
    fragment socialPostFragment on SocialPost {
  url
  image {
    ...imageFragment
  }
}
    ${ImageFragmentFragmentDoc}`;
export const SocialPostEntityFragmentFragmentDoc = gql`
    fragment socialPostEntityFragment on SocialPostEntity {
  attributes {
    ...socialPostFragment
  }
}
    ${SocialPostFragmentFragmentDoc}`;
export const SocialPostsFragmentFragmentDoc = gql`
    fragment socialPostsFragment on SocialPostRelationResponseCollection {
  data {
    ...socialPostEntityFragment
  }
}
    ${SocialPostEntityFragmentFragmentDoc}`;
export const SocialMediaFragmentDoc = gql`
    fragment SocialMedia on ComponentBlocksSocialMedia {
  titleDescription {
    ...titleDescriptionFragment
  }
  social_posts {
    ...socialPostsFragment
  }
  tightPaddingBelow
}
    ${TitleDescriptionFragmentFragmentDoc}
${SocialPostsFragmentFragmentDoc}`;
export const StarStoryFormFragmentFragmentDoc = gql`
    fragment StarStoryFormFragment on ComponentBlocksStarStoryForm {
  titleDescription {
    ...titleDescriptionFragment
  }
  tightPaddingBelow
  aboutDescription
  storyDescription
  uploadDescription
  termsAndConditions
}
    ${TitleDescriptionFragmentFragmentDoc}`;
export const StoryCardGridFragmentFragmentDoc = gql`
    fragment StoryCardGridFragment on ComponentBlocksStoryCardGrid {
  titleDescription {
    ...titleDescriptionFragment
  }
  tightPaddingBelow
}
    ${TitleDescriptionFragmentFragmentDoc}`;
export const TabFragmentFragmentDoc = gql`
    fragment TabFragment on ComponentSharedTab {
  columns {
    ...RichTextColumn
  }
  title
  headingLevel
}
    ${RichTextColumnFragmentDoc}`;
export const TabContentBlockFragmentFragmentDoc = gql`
    fragment TabContentBlockFragment on ComponentBlocksTabContentBlock {
  titleDescription {
    ...titleDescriptionFragment
  }
  tabs {
    ...TabFragment
  }
  tightPaddingBelow
}
    ${TitleDescriptionFragmentFragmentDoc}
${TabFragmentFragmentDoc}`;
export const TestimonialFragmentFragmentDoc = gql`
    fragment testimonialFragment on Testimonial {
  author
  quote
  rating
  image {
    ...imageFragment
  }
}
    ${ImageFragmentFragmentDoc}`;
export const TestimonialEntityFragmentFragmentDoc = gql`
    fragment testimonialEntityFragment on TestimonialEntity {
  attributes {
    ...testimonialFragment
  }
}
    ${TestimonialFragmentFragmentDoc}`;
export const TestimonialsFragmentFragmentDoc = gql`
    fragment testimonialsFragment on TestimonialRelationResponseCollection {
  data {
    ...testimonialEntityFragment
  }
}
    ${TestimonialEntityFragmentFragmentDoc}`;
export const BlockTestimonialsFragmentFragmentDoc = gql`
    fragment BlockTestimonialsFragment on ComponentBlocksTestimonials {
  titleDescription {
    ...titleDescriptionFragment
  }
  testimonials {
    ...testimonialsFragment
  }
  tightPaddingBelow
}
    ${TitleDescriptionFragmentFragmentDoc}
${TestimonialsFragmentFragmentDoc}`;
export const VideoFragmentFragmentDoc = gql`
    fragment VideoFragment on ComponentBlocksVideo {
  mux_video_uploader_mux_asset {
    ...muxAssetFragment
  }
  tightPaddingBelow
}
    ${MuxAssetFragmentFragmentDoc}`;
export const IconCardFragmentDoc = gql`
    fragment IconCard on IconCardRelationResponseCollection {
  __typename
  data {
    id
    attributes {
      title
      content
      icon {
        data {
          attributes {
            url
            alternativeText
          }
        }
      }
    }
  }
}
    `;
export const IconCardBlockFragmentDoc = gql`
    fragment IconCardBlock on ComponentBlocksIconCardBlock {
  titleDescription {
    ...titleDescriptionFragment
  }
  iconCards {
    ...IconCard
  }
  tightPaddingBelow
}
    ${TitleDescriptionFragmentFragmentDoc}
${IconCardFragmentDoc}`;
export const PageFragmentFragmentDoc = gql`
    fragment pageFragment on Page {
  showRegionPopup
  slug
  parentPage {
    data {
      attributes {
        title
        slug
        parentPage {
          data {
            attributes {
              title
              slug
            }
          }
        }
      }
    }
  }
  createdAt
  locale
  localizations {
    data {
      attributes {
        __typename
        locale
        slug
        parentPage {
          data {
            attributes {
              title
              slug
              parentPage {
                data {
                  attributes {
                    title
                    slug
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  publishedAt
  seo {
    ...seoFragment
  }
  title
  updatedAt
  hero {
    ...heroFragment
  }
  blocks {
    __typename
    ...AlternatingMediaWithContentBlockFragment
    ...BlocksRichTextFragment
    ...CardsBlockFragment
    ...CarouselBlockFragment
    ...CarouselStoriesFragment
    ...ContactsBlockFragment
    ...CustomerRadarBlockFragment
    ...EmbedHtmlFragment
    ...EnquiryFormFragment
    ...DealsBlockFragment
    ...FaqFragment
    ...GalleryCarouselFragment
    ...GalleryFragment
    ...MapsFragment
    ...MotorhomeDetailsFragment
    ...MotorhomeInfoTabs
    ...RichTextColumnBlock
    ...SocialMedia
    ...StarStoryFormFragment
    ...StoryCardGridFragment
    ...TabContentBlockFragment
    ...BlockTestimonialsFragment
    ...VideoFragment
    ...IconCardBlock
  }
}
    ${SeoFragmentFragmentDoc}
${HeroFragmentFragmentDoc}
${AlternatingMediaWithContentBlockFragmentFragmentDoc}
${BlocksRichTextFragmentFragmentDoc}
${CardsBlockFragmentFragmentDoc}
${CarouselBlockFragmentFragmentDoc}
${CarouselStoriesFragmentFragmentDoc}
${ContactsBlockFragmentFragmentDoc}
${CustomerRadarBlockFragmentFragmentDoc}
${EmbedHtmlFragmentFragmentDoc}
${EnquiryFormFragmentFragmentDoc}
${DealsBlockFragmentFragmentDoc}
${FaqFragmentFragmentDoc}
${GalleryCarouselFragmentFragmentDoc}
${GalleryFragmentFragmentDoc}
${MapsFragmentFragmentDoc}
${MotorhomeDetailsFragmentFragmentDoc}
${MotorhomeInfoTabsFragmentDoc}
${RichTextColumnBlockFragmentDoc}
${SocialMediaFragmentDoc}
${StarStoryFormFragmentFragmentDoc}
${StoryCardGridFragmentFragmentDoc}
${TabContentBlockFragmentFragmentDoc}
${BlockTestimonialsFragmentFragmentDoc}
${VideoFragmentFragmentDoc}
${IconCardBlockFragmentDoc}`;
export const PageSitemapFragmentFragmentDoc = gql`
    fragment PageSitemapFragment on PageEntity {
  id
  attributes {
    __typename
    slug
    locale
    localizations {
      data {
        attributes {
          __typename
          locale
          slug
          parentPage {
            data {
              attributes {
                title
                slug
                parentPage {
                  data {
                    attributes {
                      title
                      slug
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    parentPage {
      data {
        attributes {
          title
          slug
          parentPage {
            data {
              attributes {
                title
                slug
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const StoryFragmentFragmentDoc = gql`
    fragment storyFragment on Story {
  createdAt
  publishedAt
  updatedAt
  locale
  slug
  cmsTitle
  showRegionPopup
  parentPage {
    data {
      attributes {
        title
        slug
        parentPage {
          data {
            attributes {
              title
              slug
            }
          }
        }
      }
    }
  }
  hero {
    ...heroFragment
  }
  localizations {
    data {
      attributes {
        __typename
        locale
        slug
        parentPage {
          data {
            attributes {
              title
              slug
              parentPage {
                data {
                  attributes {
                    title
                    slug
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  seo {
    ...seoFragment
  }
  blocks {
    __typename
    ...BlocksRichTextFragment
    ...CardsBlockFragment
    ...CarouselBlockFragment
    ...CarouselStoriesFragment
    ...FaqFragment
    ...GalleryCarouselFragment
    ...GalleryFragment
    ...MapsFragment
    ...RichTextColumnBlock
    ...SocialMedia
    ...BlockTestimonialsFragment
    ...VideoFragment
  }
}
    ${HeroFragmentFragmentDoc}
${SeoFragmentFragmentDoc}
${BlocksRichTextFragmentFragmentDoc}
${CardsBlockFragmentFragmentDoc}
${CarouselBlockFragmentFragmentDoc}
${CarouselStoriesFragmentFragmentDoc}
${FaqFragmentFragmentDoc}
${GalleryCarouselFragmentFragmentDoc}
${GalleryFragmentFragmentDoc}
${MapsFragmentFragmentDoc}
${RichTextColumnBlockFragmentDoc}
${SocialMediaFragmentDoc}
${BlockTestimonialsFragmentFragmentDoc}
${VideoFragmentFragmentDoc}`;
export const StorySitemapFragmentFragmentDoc = gql`
    fragment StorySitemapFragment on StoryEntity {
  id
  attributes {
    __typename
    slug
    locale
    localizations {
      data {
        attributes {
          __typename
          slug
          parentPage {
            data {
              attributes {
                title
                slug
                parentPage {
                  data {
                    attributes {
                      title
                      slug
                    }
                  }
                }
              }
            }
          }
          locale
        }
      }
    }
    parentPage {
      data {
        attributes {
          title
          slug
          parentPage {
            data {
              attributes {
                title
                slug
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const FooterColumnsFragmentFragmentDoc = gql`
    fragment footerColumnsFragment on ComponentSharedFooterColumn {
  id
  footerTitle
  links {
    ...linkFragment
  }
}
    ${LinkFragmentFragmentDoc}`;
export const FooterFragmentFragmentDoc = gql`
    fragment footerFragment on ComponentGlobalFooter {
  footerColumns {
    ...footerColumnsFragment
  }
  underFooterLinks {
    ...linkFragment
  }
}
    ${FooterColumnsFragmentFragmentDoc}
${LinkFragmentFragmentDoc}`;
export const PartnerLinkFragmentFragmentDoc = gql`
    fragment partnerLinkFragment on ComponentSharedPartnerLink {
  id
  image {
    ...imageFragment
  }
  openInNew
  title
  url
}
    ${ImageFragmentFragmentDoc}`;
export const CondensedStoryFragmentFragmentDoc = gql`
    fragment condensedStoryFragment on Story {
  publishedAt
  hero {
    ...heroFragment
  }
}
    ${HeroFragmentFragmentDoc}`;
export const GetGlobalDocument = gql`
    query getGlobal($locale: I18NLocaleCode, $publicationState: PublicationState, $country: String) {
  global(locale: $locale, publicationState: $publicationState) {
    data {
      attributes {
        footer {
          ...footerFragment
        }
        partnerLinks {
          ...partnerLinkFragment
        }
      }
    }
  }
  renderNavigation(
    locale: $locale
    navigationIdOrSlug: "main-navigation"
    type: TREE
    menuOnly: false
  ) {
    id
    title
    path
    menuAttached
    items {
      id
      __typename
      title
      path
      type
    }
  }
  customerRadarFeedbacks(
    publicationState: LIVE
    sort: "publishedAt:DESC"
    pagination: {limit: 10}
    filters: {country: {eq: $country}}
  ) {
    ...customerRadarFeedbackItemsFragment
  }
}
    ${FooterFragmentFragmentDoc}
${PartnerLinkFragmentFragmentDoc}
${CustomerRadarFeedbackItemsFragmentFragmentDoc}`;

/**
 * __useGetGlobalQuery__
 *
 * To run a query within a React component, call `useGetGlobalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      publicationState: // value for 'publicationState'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetGlobalQuery(baseOptions?: Apollo.QueryHookOptions<IGetGlobalQuery, IGetGlobalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetGlobalQuery, IGetGlobalQueryVariables>(GetGlobalDocument, options);
      }
export function useGetGlobalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetGlobalQuery, IGetGlobalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetGlobalQuery, IGetGlobalQueryVariables>(GetGlobalDocument, options);
        }
export type GetGlobalQueryHookResult = ReturnType<typeof useGetGlobalQuery>;
export type GetGlobalLazyQueryHookResult = ReturnType<typeof useGetGlobalLazyQuery>;
export type GetGlobalQueryResult = Apollo.QueryResult<IGetGlobalQuery, IGetGlobalQueryVariables>;
export const GetAllPagesDocument = gql`
    query getAllPages($locale: I18NLocaleCode, $publicationState: PublicationState) {
  pages(
    locale: $locale
    filters: {slug: {not: {eq: "/"}}}
    publicationState: $publicationState
    pagination: {page: 1, pageSize: 10000}
  ) {
    data {
      ...PageFragmentParentAndSlug
    }
  }
  stories(
    locale: $locale
    filters: {slug: {not: {eq: "/"}}}
    publicationState: $publicationState
    pagination: {page: 1, pageSize: 10000}
  ) {
    data {
      ...StoryFragmentParentAndSlug
    }
  }
}
    ${PageFragmentParentAndSlugFragmentDoc}
${StoryFragmentParentAndSlugFragmentDoc}`;

/**
 * __useGetAllPagesQuery__
 *
 * To run a query within a React component, call `useGetAllPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPagesQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      publicationState: // value for 'publicationState'
 *   },
 * });
 */
export function useGetAllPagesQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllPagesQuery, IGetAllPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllPagesQuery, IGetAllPagesQueryVariables>(GetAllPagesDocument, options);
      }
export function useGetAllPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllPagesQuery, IGetAllPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllPagesQuery, IGetAllPagesQueryVariables>(GetAllPagesDocument, options);
        }
export type GetAllPagesQueryHookResult = ReturnType<typeof useGetAllPagesQuery>;
export type GetAllPagesLazyQueryHookResult = ReturnType<typeof useGetAllPagesLazyQuery>;
export type GetAllPagesQueryResult = Apollo.QueryResult<IGetAllPagesQuery, IGetAllPagesQueryVariables>;
export const GetAllPagesForSitemapDocument = gql`
    query getAllPagesForSitemap($locale: I18NLocaleCode) {
  pages(locale: $locale, pagination: {page: 1, pageSize: 10000}) {
    data {
      ...PageSitemapFragment
    }
  }
  stories(locale: $locale, pagination: {page: 1, pageSize: 10000}) {
    data {
      ...StorySitemapFragment
    }
  }
}
    ${PageSitemapFragmentFragmentDoc}
${StorySitemapFragmentFragmentDoc}`;

/**
 * __useGetAllPagesForSitemapQuery__
 *
 * To run a query within a React component, call `useGetAllPagesForSitemapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPagesForSitemapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPagesForSitemapQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetAllPagesForSitemapQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllPagesForSitemapQuery, IGetAllPagesForSitemapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllPagesForSitemapQuery, IGetAllPagesForSitemapQueryVariables>(GetAllPagesForSitemapDocument, options);
      }
export function useGetAllPagesForSitemapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllPagesForSitemapQuery, IGetAllPagesForSitemapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllPagesForSitemapQuery, IGetAllPagesForSitemapQueryVariables>(GetAllPagesForSitemapDocument, options);
        }
export type GetAllPagesForSitemapQueryHookResult = ReturnType<typeof useGetAllPagesForSitemapQuery>;
export type GetAllPagesForSitemapLazyQueryHookResult = ReturnType<typeof useGetAllPagesForSitemapLazyQuery>;
export type GetAllPagesForSitemapQueryResult = Apollo.QueryResult<IGetAllPagesForSitemapQuery, IGetAllPagesForSitemapQueryVariables>;
export const GetAllStoriesDocument = gql`
    query getAllStories($locale: I18NLocaleCode, $publicationState: PublicationState) {
  stories(
    pagination: {page: 1, pageSize: 10000}
    locale: $locale
    filters: {slug: {not: {eq: "/"}}}
    publicationState: $publicationState
  ) {
    data {
      ...StoryFragmentParentAndSlug
      attributes {
        ...condensedStoryFragment
      }
    }
  }
}
    ${StoryFragmentParentAndSlugFragmentDoc}
${CondensedStoryFragmentFragmentDoc}`;

/**
 * __useGetAllStoriesQuery__
 *
 * To run a query within a React component, call `useGetAllStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStoriesQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      publicationState: // value for 'publicationState'
 *   },
 * });
 */
export function useGetAllStoriesQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllStoriesQuery, IGetAllStoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllStoriesQuery, IGetAllStoriesQueryVariables>(GetAllStoriesDocument, options);
      }
export function useGetAllStoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllStoriesQuery, IGetAllStoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllStoriesQuery, IGetAllStoriesQueryVariables>(GetAllStoriesDocument, options);
        }
export type GetAllStoriesQueryHookResult = ReturnType<typeof useGetAllStoriesQuery>;
export type GetAllStoriesLazyQueryHookResult = ReturnType<typeof useGetAllStoriesLazyQuery>;
export type GetAllStoriesQueryResult = Apollo.QueryResult<IGetAllStoriesQuery, IGetAllStoriesQueryVariables>;
export const GetBasicPageDocument = gql`
    query getBasicPage($locale: I18NLocaleCode) {
  pages(
    filters: {slug: {eq: "/"}}
    locale: $locale
    pagination: {page: 1, pageSize: 10000}
  ) {
    data {
      id
      attributes {
        slug
        parentPage {
          data {
            attributes {
              slug
              parentPage {
                data {
                  attributes {
                    slug
                  }
                }
              }
            }
          }
        }
        createdAt
        locale
        publishedAt
        seo {
          ...seoFragment
        }
        title
        updatedAt
      }
    }
  }
}
    ${SeoFragmentFragmentDoc}`;

/**
 * __useGetBasicPageQuery__
 *
 * To run a query within a React component, call `useGetBasicPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasicPageQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetBasicPageQuery(baseOptions?: Apollo.QueryHookOptions<IGetBasicPageQuery, IGetBasicPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetBasicPageQuery, IGetBasicPageQueryVariables>(GetBasicPageDocument, options);
      }
export function useGetBasicPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetBasicPageQuery, IGetBasicPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetBasicPageQuery, IGetBasicPageQueryVariables>(GetBasicPageDocument, options);
        }
export type GetBasicPageQueryHookResult = ReturnType<typeof useGetBasicPageQuery>;
export type GetBasicPageLazyQueryHookResult = ReturnType<typeof useGetBasicPageLazyQuery>;
export type GetBasicPageQueryResult = Apollo.QueryResult<IGetBasicPageQuery, IGetBasicPageQueryVariables>;
export const GetPageDocument = gql`
    query getPage($slug: String, $locale: I18NLocaleCode, $publicationState: PublicationState) {
  pages(
    filters: {slug: {eq: $slug}}
    locale: $locale
    publicationState: $publicationState
    pagination: {page: 1, pageSize: 10000}
  ) {
    data {
      id
      attributes {
        ...pageFragment
      }
    }
  }
  stories(
    filters: {slug: {eq: $slug}}
    locale: $locale
    publicationState: $publicationState
    pagination: {page: 1, pageSize: 10000}
  ) {
    data {
      id
      attributes {
        ...storyFragment
      }
    }
  }
}
    ${PageFragmentFragmentDoc}
${StoryFragmentFragmentDoc}`;

/**
 * __useGetPageQuery__
 *
 * To run a query within a React component, call `useGetPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      locale: // value for 'locale'
 *      publicationState: // value for 'publicationState'
 *   },
 * });
 */
export function useGetPageQuery(baseOptions?: Apollo.QueryHookOptions<IGetPageQuery, IGetPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetPageQuery, IGetPageQueryVariables>(GetPageDocument, options);
      }
export function useGetPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetPageQuery, IGetPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetPageQuery, IGetPageQueryVariables>(GetPageDocument, options);
        }
export type GetPageQueryHookResult = ReturnType<typeof useGetPageQuery>;
export type GetPageLazyQueryHookResult = ReturnType<typeof useGetPageLazyQuery>;
export type GetPageQueryResult = Apollo.QueryResult<IGetPageQuery, IGetPageQueryVariables>;
export type ICardFragment = { __typename?: 'Card', Card?: { __typename?: 'ComponentSharedCards', id: string, backgroundColour?: IEnum_Componentsharedcards_Backgroundcolour, tintImage?: boolean, eyebrowText?: string, title?: string, description?: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } }, video?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, link?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } };

export type ICardCollectionFragment = { __typename: 'CardCollectionRelationResponseCollection', data: Array<{ __typename: 'CardCollectionEntity', id?: string, attributes?: { __typename?: 'CardCollection', reverseOrderOnMobile?: boolean, cards?: { __typename?: 'CardRelationResponseCollection', data: Array<{ __typename?: 'CardEntity', id?: string, attributes?: { __typename?: 'Card', Card?: { __typename?: 'ComponentSharedCards', id: string, backgroundColour?: IEnum_Componentsharedcards_Backgroundcolour, tintImage?: boolean, eyebrowText?: string, title?: string, description?: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } }, video?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, link?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } }> } } }> };

export type ICustomerRadarFeedbackFragmentFragment = { __typename?: 'CustomerRadarFeedback', author: string, country?: string, countryOfOrigin?: string, publishedAt?: any, date?: any, fleetCategory?: string, quote: string, rating: number };

export type ICustomerRadarFeedbackEntityFragmentFragment = { __typename?: 'CustomerRadarFeedbackEntity', attributes?: { __typename?: 'CustomerRadarFeedback', author: string, country?: string, countryOfOrigin?: string, publishedAt?: any, date?: any, fleetCategory?: string, quote: string, rating: number } };

export type ICustomerRadarFeedbackItemsFragmentFragment = { __typename?: 'CustomerRadarFeedbackEntityResponseCollection', data: Array<{ __typename?: 'CustomerRadarFeedbackEntity', attributes?: { __typename?: 'CustomerRadarFeedback', author: string, country?: string, countryOfOrigin?: string, publishedAt?: any, date?: any, fleetCategory?: string, quote: string, rating: number } }> };

export type IFaqItemFragmentFragment = { __typename?: 'FaqItem', answer: string, createdAt?: any, question: string, updatedAt?: any };

export type IFaqItemEntityFragmentFragment = { __typename?: 'FaqItemEntity', attributes?: { __typename?: 'FaqItem', answer: string, createdAt?: any, question: string, updatedAt?: any } };

export type IFaqItemsFragmentFragment = { __typename?: 'FaqItemRelationResponseCollection', data: Array<{ __typename?: 'FaqItemEntity', attributes?: { __typename?: 'FaqItem', answer: string, createdAt?: any, question: string, updatedAt?: any } }> };

export type IIconCardFragment = { __typename: 'IconCardRelationResponseCollection', data: Array<{ __typename?: 'IconCardEntity', id?: string, attributes?: { __typename?: 'IconCard', title?: string, content?: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } } } }> };

export type IImageAttributesFragmentFragment = { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number };

export type IImageDataFragmentFragment = { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } };

export type IImageFragmentFragment = { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } };

export type IImageCollectionFragmentFragment = { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } }> };

export type IMediaWithContentFragmentFragment = { __typename: 'MediaWithContentRelationResponseCollection', data: Array<{ __typename: 'MediaWithContentEntity', id?: string, attributes?: { __typename?: 'MediaWithContent', title?: string, description?: string, mediaAlignment: IEnum_Mediawithcontent_Mediaalignment, link?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } }, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } }, video?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } } } }> };

export type IMuxVideoUploaderAssetFragmentFragment = { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number };

export type IMuxVideoUploaderFragmentFragment = { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } };

export type IMuxAssetFragmentFragment = { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } };

export type IPageFragmentFragment = { __typename?: 'Page', showRegionPopup?: boolean, slug: string, createdAt?: any, locale?: string, publishedAt?: any, title: string, updatedAt?: any, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } }, localizations?: { __typename?: 'PageRelationResponseCollection', data: Array<{ __typename?: 'PageEntity', attributes?: { __typename: 'Page', locale?: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } }> }, seo: { __typename?: 'ComponentSharedSeo', metaTitle: string, metaDescription: string, keywords?: string, canonicalURL?: string, metaRobots?: string, customLdJson?: any, metaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } }, metaSocial?: Array<{ __typename?: 'ComponentSharedMetaSocial', socialNetwork: IEnum_Componentsharedmetasocial_Socialnetwork, title: string, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }> }, hero?: { __typename?: 'ComponentSharedHero', title?: string, description?: string, showBookingBar?: boolean, showBreadcrumbs?: boolean, bookingBarText?: string, image?: { __typename?: 'ComponentSharedHeroImage', variant: IEnum_Componentsharedheroimage_Variant, descriptionHighlight?: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }, video?: { __typename?: 'ComponentSharedHeroVideo', eyebrowText?: string, backgroundVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, fullVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, mobileSecondaryCta?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } }, blocks?: Array<{ __typename: 'ComponentBlocksAltContent', backgroundColour?: IEnum_Componentblocksaltcontent_Backgroundcolour, tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, mediaWithContent?: { __typename: 'MediaWithContentRelationResponseCollection', data: Array<{ __typename: 'MediaWithContentEntity', id?: string, attributes?: { __typename?: 'MediaWithContent', title?: string, description?: string, mediaAlignment: IEnum_Mediawithcontent_Mediaalignment, link?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } }, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } }, video?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } } } }> } } | { __typename: 'ComponentBlocksCardsBlock', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, card_collections?: { __typename: 'CardCollectionRelationResponseCollection', data: Array<{ __typename: 'CardCollectionEntity', id?: string, attributes?: { __typename?: 'CardCollection', reverseOrderOnMobile?: boolean, cards?: { __typename?: 'CardRelationResponseCollection', data: Array<{ __typename?: 'CardEntity', id?: string, attributes?: { __typename?: 'Card', Card?: { __typename?: 'ComponentSharedCards', id: string, backgroundColour?: IEnum_Componentsharedcards_Backgroundcolour, tintImage?: boolean, eyebrowText?: string, title?: string, description?: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } }, video?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, link?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } }> } } }> } } | { __typename: 'ComponentBlocksCarouselBlock', slidesPerView: IEnum_Componentblockscarouselblock_Slidesperview, tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, cards?: { __typename?: 'CardRelationResponseCollection', data: Array<{ __typename?: 'CardEntity', id?: string, attributes?: { __typename?: 'Card', Card?: { __typename?: 'ComponentSharedCards', id: string, backgroundColour?: IEnum_Componentsharedcards_Backgroundcolour, tintImage?: boolean, eyebrowText?: string, title?: string, description?: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } }, video?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, link?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } }> } } | { __typename: 'ComponentBlocksCarouselStories', tightPaddingBelow?: boolean, variant?: IEnum_Componentblockscarouselstories_Variant, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, stories?: { __typename?: 'StoryRelationResponseCollection', data: Array<{ __typename?: 'StoryEntity', id?: string, attributes?: { __typename?: 'Story', slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug: string } } } } } }, hero?: { __typename?: 'ComponentSharedHero', title?: string, description?: string, showBookingBar?: boolean, showBreadcrumbs?: boolean, bookingBarText?: string, image?: { __typename?: 'ComponentSharedHeroImage', variant: IEnum_Componentsharedheroimage_Variant, descriptionHighlight?: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }, video?: { __typename?: 'ComponentSharedHeroVideo', eyebrowText?: string, backgroundVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, fullVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, mobileSecondaryCta?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } } }> } } | { __typename: 'ComponentBlocksContacts', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, columns: Array<{ __typename?: 'ComponentSharedContactBlockColumn', title: string, links: Array<{ __typename?: 'ComponentSharedContactColumnLinks', title: string, link: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }> }> } | { __typename: 'ComponentBlocksCustomerRadarFeedbackBlock', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } | { __typename: 'ComponentBlocksDealsBlock', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } | { __typename: 'ComponentBlocksEmbedHtml', id: string, tightPaddingBelow?: boolean, embedCode?: string, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } | { __typename: 'ComponentBlocksEnquiryForm', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } | { __typename: 'ComponentBlocksFaq', ctaDescription?: string, tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, faqs?: { __typename?: 'FaqItemRelationResponseCollection', data: Array<{ __typename?: 'FaqItemEntity', attributes?: { __typename?: 'FaqItem', answer: string, createdAt?: any, question: string, updatedAt?: any } }> }, ctaButton?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } | { __typename: 'ComponentBlocksGallery', tightPaddingBelow?: boolean, galleryImages: Array<{ __typename?: 'ComponentSharedImageField', image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }> } | { __typename: 'ComponentBlocksGalleryCarousel', eyebrowTitle?: string, tightPaddingBelow?: boolean, galleryCarouselImages: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } }> } } | { __typename: 'ComponentBlocksIconCardBlock', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, iconCards?: { __typename: 'IconCardRelationResponseCollection', data: Array<{ __typename?: 'IconCardEntity', id?: string, attributes?: { __typename?: 'IconCard', title?: string, content?: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } } } }> } } | { __typename: 'ComponentBlocksMap', tightPaddingBelow?: boolean, customMarkers?: Array<{ __typename?: 'ComponentSharedMapMarker', location?: any }>, branchLocations?: Array<{ __typename?: 'ComponentSharedBranchLocations', branchLocations?: IEnum_Componentsharedbranchlocations_Branchlocations }> } | { __typename: 'ComponentBlocksMotorhomeDetails', fleet: string, id: string, tightPaddingBelow?: boolean } | { __typename: 'ComponentBlocksMotorhomeInfoTabs', tightPaddingBelow?: boolean, infoTabs: Array<{ __typename?: 'ComponentSharedMotorhomeInfoTab', highlight?: string }> } | { __typename: 'ComponentBlocksRichText', richText: string, tightPaddingBelow?: boolean } | { __typename: 'ComponentBlocksRichTextColumns', addBackgroundColour?: boolean, tightPaddingBelow?: boolean, richTextColumns: Array<{ __typename?: 'ComponentSharedRichTextColumn', richText: string }>, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } | { __typename: 'ComponentBlocksSocialMedia', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, social_posts?: { __typename?: 'SocialPostRelationResponseCollection', data: Array<{ __typename?: 'SocialPostEntity', attributes?: { __typename?: 'SocialPost', url: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } } }> } } | { __typename: 'ComponentBlocksStarStoryForm', tightPaddingBelow?: boolean, aboutDescription?: string, storyDescription?: string, uploadDescription?: string, termsAndConditions?: string, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } | { __typename: 'ComponentBlocksStoryCardGrid', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } | { __typename: 'ComponentBlocksTabContentBlock', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, tabs: Array<{ __typename?: 'ComponentSharedTab', title: string, headingLevel?: IEnum_Componentsharedtab_Headinglevel, columns?: Array<{ __typename?: 'ComponentSharedRichTextColumn', richText: string }> }> } | { __typename: 'ComponentBlocksTestimonials', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, testimonials?: { __typename?: 'TestimonialRelationResponseCollection', data: Array<{ __typename?: 'TestimonialEntity', attributes?: { __typename?: 'Testimonial', author?: string, quote?: string, rating?: number, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } } }> } } | { __typename: 'ComponentBlocksVideo', tightPaddingBelow?: boolean, mux_video_uploader_mux_asset?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } } } | { __typename: 'Error' }> };

export type IPageFragmentParentAndSlugFragment = { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } };

export type IPageSitemapFragmentFragment = { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', slug: string, locale?: string, localizations?: { __typename?: 'PageRelationResponseCollection', data: Array<{ __typename?: 'PageEntity', attributes?: { __typename: 'Page', locale?: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } }> }, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } };

export type ISocialPostFragmentFragment = { __typename?: 'SocialPost', url: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } };

export type ISocialPostEntityFragmentFragment = { __typename?: 'SocialPostEntity', attributes?: { __typename?: 'SocialPost', url: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } } };

export type ISocialPostsFragmentFragment = { __typename?: 'SocialPostRelationResponseCollection', data: Array<{ __typename?: 'SocialPostEntity', attributes?: { __typename?: 'SocialPost', url: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } } }> };

export type IStoryFragmentFragment = { __typename?: 'Story', createdAt?: any, publishedAt?: any, updatedAt?: any, locale?: string, slug: string, cmsTitle: string, showRegionPopup?: boolean, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } }, hero?: { __typename?: 'ComponentSharedHero', title?: string, description?: string, showBookingBar?: boolean, showBreadcrumbs?: boolean, bookingBarText?: string, image?: { __typename?: 'ComponentSharedHeroImage', variant: IEnum_Componentsharedheroimage_Variant, descriptionHighlight?: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }, video?: { __typename?: 'ComponentSharedHeroVideo', eyebrowText?: string, backgroundVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, fullVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, mobileSecondaryCta?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } }, localizations?: { __typename?: 'StoryRelationResponseCollection', data: Array<{ __typename?: 'StoryEntity', attributes?: { __typename: 'Story', locale?: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } }> }, seo: { __typename?: 'ComponentSharedSeo', metaTitle: string, metaDescription: string, keywords?: string, canonicalURL?: string, metaRobots?: string, customLdJson?: any, metaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } }, metaSocial?: Array<{ __typename?: 'ComponentSharedMetaSocial', socialNetwork: IEnum_Componentsharedmetasocial_Socialnetwork, title: string, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }> }, blocks?: Array<{ __typename: 'ComponentBlocksCardsBlock', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, card_collections?: { __typename: 'CardCollectionRelationResponseCollection', data: Array<{ __typename: 'CardCollectionEntity', id?: string, attributes?: { __typename?: 'CardCollection', reverseOrderOnMobile?: boolean, cards?: { __typename?: 'CardRelationResponseCollection', data: Array<{ __typename?: 'CardEntity', id?: string, attributes?: { __typename?: 'Card', Card?: { __typename?: 'ComponentSharedCards', id: string, backgroundColour?: IEnum_Componentsharedcards_Backgroundcolour, tintImage?: boolean, eyebrowText?: string, title?: string, description?: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } }, video?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, link?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } }> } } }> } } | { __typename: 'ComponentBlocksCarouselBlock', slidesPerView: IEnum_Componentblockscarouselblock_Slidesperview, tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, cards?: { __typename?: 'CardRelationResponseCollection', data: Array<{ __typename?: 'CardEntity', id?: string, attributes?: { __typename?: 'Card', Card?: { __typename?: 'ComponentSharedCards', id: string, backgroundColour?: IEnum_Componentsharedcards_Backgroundcolour, tintImage?: boolean, eyebrowText?: string, title?: string, description?: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } }, video?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, link?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } }> } } | { __typename: 'ComponentBlocksCarouselStories', tightPaddingBelow?: boolean, variant?: IEnum_Componentblockscarouselstories_Variant, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, stories?: { __typename?: 'StoryRelationResponseCollection', data: Array<{ __typename?: 'StoryEntity', id?: string, attributes?: { __typename?: 'Story', slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug: string } } } } } }, hero?: { __typename?: 'ComponentSharedHero', title?: string, description?: string, showBookingBar?: boolean, showBreadcrumbs?: boolean, bookingBarText?: string, image?: { __typename?: 'ComponentSharedHeroImage', variant: IEnum_Componentsharedheroimage_Variant, descriptionHighlight?: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }, video?: { __typename?: 'ComponentSharedHeroVideo', eyebrowText?: string, backgroundVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, fullVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, mobileSecondaryCta?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } } }> } } | { __typename: 'ComponentBlocksContacts' } | { __typename: 'ComponentBlocksDealsBlock' } | { __typename: 'ComponentBlocksFaq', ctaDescription?: string, tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, faqs?: { __typename?: 'FaqItemRelationResponseCollection', data: Array<{ __typename?: 'FaqItemEntity', attributes?: { __typename?: 'FaqItem', answer: string, createdAt?: any, question: string, updatedAt?: any } }> }, ctaButton?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } | { __typename: 'ComponentBlocksGallery', tightPaddingBelow?: boolean, galleryImages: Array<{ __typename?: 'ComponentSharedImageField', image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }> } | { __typename: 'ComponentBlocksGalleryCarousel', eyebrowTitle?: string, tightPaddingBelow?: boolean, galleryCarouselImages: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } }> } } | { __typename: 'ComponentBlocksMap', tightPaddingBelow?: boolean, customMarkers?: Array<{ __typename?: 'ComponentSharedMapMarker', location?: any }>, branchLocations?: Array<{ __typename?: 'ComponentSharedBranchLocations', branchLocations?: IEnum_Componentsharedbranchlocations_Branchlocations }> } | { __typename: 'ComponentBlocksRichText', richText: string, tightPaddingBelow?: boolean } | { __typename: 'ComponentBlocksRichTextColumns', addBackgroundColour?: boolean, tightPaddingBelow?: boolean, richTextColumns: Array<{ __typename?: 'ComponentSharedRichTextColumn', richText: string }>, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } | { __typename: 'ComponentBlocksSocialMedia', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, social_posts?: { __typename?: 'SocialPostRelationResponseCollection', data: Array<{ __typename?: 'SocialPostEntity', attributes?: { __typename?: 'SocialPost', url: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } } }> } } | { __typename: 'ComponentBlocksStoryCardGrid' } | { __typename: 'ComponentBlocksTestimonials', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, testimonials?: { __typename?: 'TestimonialRelationResponseCollection', data: Array<{ __typename?: 'TestimonialEntity', attributes?: { __typename?: 'Testimonial', author?: string, quote?: string, rating?: number, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } } }> } } | { __typename: 'ComponentBlocksVideo', tightPaddingBelow?: boolean, mux_video_uploader_mux_asset?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } } } | { __typename: 'Error' }> };

export type IStoryFragmentParentAndSlugFragment = { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } };

export type IStorySitemapFragmentFragment = { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', slug: string, locale?: string, localizations?: { __typename?: 'StoryRelationResponseCollection', data: Array<{ __typename?: 'StoryEntity', attributes?: { __typename: 'Story', slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } }> }, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } };

export type ITestimonialFragmentFragment = { __typename?: 'Testimonial', author?: string, quote?: string, rating?: number, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } };

export type ITestimonialEntityFragmentFragment = { __typename?: 'TestimonialEntity', attributes?: { __typename?: 'Testimonial', author?: string, quote?: string, rating?: number, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } } };

export type ITestimonialsFragmentFragment = { __typename?: 'TestimonialRelationResponseCollection', data: Array<{ __typename?: 'TestimonialEntity', attributes?: { __typename?: 'Testimonial', author?: string, quote?: string, rating?: number, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } } }> };

export type IAlternatingMediaWithContentBlockFragmentFragment = { __typename?: 'ComponentBlocksAltContent', backgroundColour?: IEnum_Componentblocksaltcontent_Backgroundcolour, tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, mediaWithContent?: { __typename: 'MediaWithContentRelationResponseCollection', data: Array<{ __typename: 'MediaWithContentEntity', id?: string, attributes?: { __typename?: 'MediaWithContent', title?: string, description?: string, mediaAlignment: IEnum_Mediawithcontent_Mediaalignment, link?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } }, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } }, video?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } } } }> } };

export type ICardsBlockFragmentFragment = { __typename?: 'ComponentBlocksCardsBlock', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, card_collections?: { __typename: 'CardCollectionRelationResponseCollection', data: Array<{ __typename: 'CardCollectionEntity', id?: string, attributes?: { __typename?: 'CardCollection', reverseOrderOnMobile?: boolean, cards?: { __typename?: 'CardRelationResponseCollection', data: Array<{ __typename?: 'CardEntity', id?: string, attributes?: { __typename?: 'Card', Card?: { __typename?: 'ComponentSharedCards', id: string, backgroundColour?: IEnum_Componentsharedcards_Backgroundcolour, tintImage?: boolean, eyebrowText?: string, title?: string, description?: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } }, video?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, link?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } }> } } }> } };

export type ICarouselBlockFragmentFragment = { __typename?: 'ComponentBlocksCarouselBlock', slidesPerView: IEnum_Componentblockscarouselblock_Slidesperview, tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, cards?: { __typename?: 'CardRelationResponseCollection', data: Array<{ __typename?: 'CardEntity', id?: string, attributes?: { __typename?: 'Card', Card?: { __typename?: 'ComponentSharedCards', id: string, backgroundColour?: IEnum_Componentsharedcards_Backgroundcolour, tintImage?: boolean, eyebrowText?: string, title?: string, description?: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } }, video?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, link?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } }> } };

export type ICarouselStoriesFragmentFragment = { __typename?: 'ComponentBlocksCarouselStories', tightPaddingBelow?: boolean, variant?: IEnum_Componentblockscarouselstories_Variant, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, stories?: { __typename?: 'StoryRelationResponseCollection', data: Array<{ __typename?: 'StoryEntity', id?: string, attributes?: { __typename?: 'Story', slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug: string } } } } } }, hero?: { __typename?: 'ComponentSharedHero', title?: string, description?: string, showBookingBar?: boolean, showBreadcrumbs?: boolean, bookingBarText?: string, image?: { __typename?: 'ComponentSharedHeroImage', variant: IEnum_Componentsharedheroimage_Variant, descriptionHighlight?: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }, video?: { __typename?: 'ComponentSharedHeroVideo', eyebrowText?: string, backgroundVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, fullVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, mobileSecondaryCta?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } } }> } };

export type IContactLinksFragment = { __typename?: 'ComponentSharedContactColumnLinks', title: string, link: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } };

export type IContactColumnsFragment = { __typename?: 'ComponentSharedContactBlockColumn', title: string, links: Array<{ __typename?: 'ComponentSharedContactColumnLinks', title: string, link: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }> };

export type IContactsBlockFragmentFragment = { __typename?: 'ComponentBlocksContacts', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, columns: Array<{ __typename?: 'ComponentSharedContactBlockColumn', title: string, links: Array<{ __typename?: 'ComponentSharedContactColumnLinks', title: string, link: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }> }> };

export type ICustomerRadarBlockFragmentFragment = { __typename?: 'ComponentBlocksCustomerRadarFeedbackBlock', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } };

export type IDealsBlockFragmentFragment = { __typename?: 'ComponentBlocksDealsBlock', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } };

export type IEmbedHtmlFragmentFragment = { __typename: 'ComponentBlocksEmbedHtml', id: string, tightPaddingBelow?: boolean, embedCode?: string, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } };

export type IEnquiryFormFragmentFragment = { __typename?: 'ComponentBlocksEnquiryForm', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } };

export type IFaqFragmentFragment = { __typename?: 'ComponentBlocksFaq', ctaDescription?: string, tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, faqs?: { __typename?: 'FaqItemRelationResponseCollection', data: Array<{ __typename?: 'FaqItemEntity', attributes?: { __typename?: 'FaqItem', answer: string, createdAt?: any, question: string, updatedAt?: any } }> }, ctaButton?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } };

export type IGalleryFragmentFragment = { __typename?: 'ComponentBlocksGallery', tightPaddingBelow?: boolean, galleryImages: Array<{ __typename?: 'ComponentSharedImageField', image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }> };

export type IGalleryCarouselFragmentFragment = { __typename?: 'ComponentBlocksGalleryCarousel', eyebrowTitle?: string, tightPaddingBelow?: boolean, galleryCarouselImages: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } }> } };

export type IIconCardBlockFragment = { __typename?: 'ComponentBlocksIconCardBlock', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, iconCards?: { __typename: 'IconCardRelationResponseCollection', data: Array<{ __typename?: 'IconCardEntity', id?: string, attributes?: { __typename?: 'IconCard', title?: string, content?: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } } } }> } };

export type IMapMarkerFragmentFragment = { __typename?: 'ComponentSharedMapMarker', location?: any };

export type IBranchLocationsFragment = { __typename?: 'ComponentSharedBranchLocations', branchLocations?: IEnum_Componentsharedbranchlocations_Branchlocations };

export type IMapsFragmentFragment = { __typename?: 'ComponentBlocksMap', tightPaddingBelow?: boolean, customMarkers?: Array<{ __typename?: 'ComponentSharedMapMarker', location?: any }>, branchLocations?: Array<{ __typename?: 'ComponentSharedBranchLocations', branchLocations?: IEnum_Componentsharedbranchlocations_Branchlocations }> };

export type IInfoTabFragmentFragment = { __typename?: 'ComponentSharedMotorhomeInfoTab', highlight?: string };

export type IMotorhomeInfoTabsFragment = { __typename?: 'ComponentBlocksMotorhomeInfoTabs', tightPaddingBelow?: boolean, infoTabs: Array<{ __typename?: 'ComponentSharedMotorhomeInfoTab', highlight?: string }> };

export type IMotorhomeDetailsFragmentFragment = { __typename?: 'ComponentBlocksMotorhomeDetails', fleet: string, id: string, tightPaddingBelow?: boolean };

export type IRichTextColumnBlockFragment = { __typename?: 'ComponentBlocksRichTextColumns', addBackgroundColour?: boolean, tightPaddingBelow?: boolean, richTextColumns: Array<{ __typename?: 'ComponentSharedRichTextColumn', richText: string }>, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } };

export type IBlocksRichTextFragmentFragment = { __typename?: 'ComponentBlocksRichText', richText: string, tightPaddingBelow?: boolean };

export type ISocialMediaFragment = { __typename?: 'ComponentBlocksSocialMedia', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, social_posts?: { __typename?: 'SocialPostRelationResponseCollection', data: Array<{ __typename?: 'SocialPostEntity', attributes?: { __typename?: 'SocialPost', url: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } } }> } };

export type IStarStoryFormFragmentFragment = { __typename?: 'ComponentBlocksStarStoryForm', tightPaddingBelow?: boolean, aboutDescription?: string, storyDescription?: string, uploadDescription?: string, termsAndConditions?: string, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } };

export type IStoryCardGridFragmentFragment = { __typename?: 'ComponentBlocksStoryCardGrid', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } };

export type ITabContentBlockFragmentFragment = { __typename?: 'ComponentBlocksTabContentBlock', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, tabs: Array<{ __typename?: 'ComponentSharedTab', title: string, headingLevel?: IEnum_Componentsharedtab_Headinglevel, columns?: Array<{ __typename?: 'ComponentSharedRichTextColumn', richText: string }> }> };

export type IBlockTestimonialsFragmentFragment = { __typename?: 'ComponentBlocksTestimonials', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, testimonials?: { __typename?: 'TestimonialRelationResponseCollection', data: Array<{ __typename?: 'TestimonialEntity', attributes?: { __typename?: 'Testimonial', author?: string, quote?: string, rating?: number, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } } }> } };

export type IVideoFragmentFragment = { __typename?: 'ComponentBlocksVideo', tightPaddingBelow?: boolean, mux_video_uploader_mux_asset?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } } };

export type IHeroFragmentFragment = { __typename?: 'ComponentSharedHero', title?: string, description?: string, showBookingBar?: boolean, showBreadcrumbs?: boolean, bookingBarText?: string, image?: { __typename?: 'ComponentSharedHeroImage', variant: IEnum_Componentsharedheroimage_Variant, descriptionHighlight?: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }, video?: { __typename?: 'ComponentSharedHeroVideo', eyebrowText?: string, backgroundVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, fullVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, mobileSecondaryCta?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } };

export type IHeroImageFragmentFragment = { __typename?: 'ComponentSharedHeroImage', variant: IEnum_Componentsharedheroimage_Variant, descriptionHighlight?: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } };

export type IHeroVideoFragmentFragment = { __typename?: 'ComponentSharedHeroVideo', eyebrowText?: string, backgroundVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, fullVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, mobileSecondaryCta?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } };

export type IImageFieldFragment = { __typename?: 'ComponentSharedImageField', image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } };

export type ILinkFragmentFragment = { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } };

export type IRichTextColumnFragment = { __typename?: 'ComponentSharedRichTextColumn', richText: string };

export type IMetaSocialFragmentFragment = { __typename?: 'ComponentSharedMetaSocial', socialNetwork: IEnum_Componentsharedmetasocial_Socialnetwork, title: string, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } };

export type ISeoFragmentFragment = { __typename?: 'ComponentSharedSeo', metaTitle: string, metaDescription: string, keywords?: string, canonicalURL?: string, metaRobots?: string, customLdJson?: any, metaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } }, metaSocial?: Array<{ __typename?: 'ComponentSharedMetaSocial', socialNetwork: IEnum_Componentsharedmetasocial_Socialnetwork, title: string, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }> };

export type ITabFragmentFragment = { __typename?: 'ComponentSharedTab', title: string, headingLevel?: IEnum_Componentsharedtab_Headinglevel, columns?: Array<{ __typename?: 'ComponentSharedRichTextColumn', richText: string }> };

export type ITitleDescriptionFragmentFragment = { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } };

export type IFooterColumnsFragmentFragment = { __typename?: 'ComponentSharedFooterColumn', id: string, footerTitle: string, links: Array<{ __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } }> };

export type IFooterFragmentFragment = { __typename?: 'ComponentGlobalFooter', footerColumns: Array<{ __typename?: 'ComponentSharedFooterColumn', id: string, footerTitle: string, links: Array<{ __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } }> }>, underFooterLinks: Array<{ __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } }> };

export type IPartnerLinkFragmentFragment = { __typename?: 'ComponentSharedPartnerLink', id: string, openInNew?: boolean, title?: string, url?: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } };

export type IGetGlobalQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<IPublicationState>;
  country?: InputMaybe<Scalars['String']['input']>;
}>;


export type IGetGlobalQuery = { __typename?: 'Query', global?: { __typename?: 'GlobalEntityResponse', data?: { __typename?: 'GlobalEntity', attributes?: { __typename?: 'Global', footer: { __typename?: 'ComponentGlobalFooter', footerColumns: Array<{ __typename?: 'ComponentSharedFooterColumn', id: string, footerTitle: string, links: Array<{ __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } }> }>, underFooterLinks: Array<{ __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } }> }, partnerLinks?: Array<{ __typename?: 'ComponentSharedPartnerLink', id: string, openInNew?: boolean, title?: string, url?: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }> } } }, renderNavigation: Array<{ __typename?: 'NavigationItem', id: number, title: string, path?: string, menuAttached: boolean, items?: Array<{ __typename: 'NavigationItem', id: number, title: string, path?: string, type: string }> }>, customerRadarFeedbacks?: { __typename?: 'CustomerRadarFeedbackEntityResponseCollection', data: Array<{ __typename?: 'CustomerRadarFeedbackEntity', attributes?: { __typename?: 'CustomerRadarFeedback', author: string, country?: string, countryOfOrigin?: string, publishedAt?: any, date?: any, fleetCategory?: string, quote: string, rating: number } }> } };

export type IGetAllPagesQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<IPublicationState>;
}>;


export type IGetAllPagesQuery = { __typename?: 'Query', pages?: { __typename?: 'PageEntityResponseCollection', data: Array<{ __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } }> }, stories?: { __typename?: 'StoryEntityResponseCollection', data: Array<{ __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } }> } };

export type IGetAllPagesForSitemapQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type IGetAllPagesForSitemapQuery = { __typename?: 'Query', pages?: { __typename?: 'PageEntityResponseCollection', data: Array<{ __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', slug: string, locale?: string, localizations?: { __typename?: 'PageRelationResponseCollection', data: Array<{ __typename?: 'PageEntity', attributes?: { __typename: 'Page', locale?: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } }> }, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } }> }, stories?: { __typename?: 'StoryEntityResponseCollection', data: Array<{ __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', slug: string, locale?: string, localizations?: { __typename?: 'StoryRelationResponseCollection', data: Array<{ __typename?: 'StoryEntity', attributes?: { __typename: 'Story', slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } }> }, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } }> } };

export type ICondensedStoryFragmentFragment = { __typename?: 'Story', publishedAt?: any, hero?: { __typename?: 'ComponentSharedHero', title?: string, description?: string, showBookingBar?: boolean, showBreadcrumbs?: boolean, bookingBarText?: string, image?: { __typename?: 'ComponentSharedHeroImage', variant: IEnum_Componentsharedheroimage_Variant, descriptionHighlight?: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }, video?: { __typename?: 'ComponentSharedHeroVideo', eyebrowText?: string, backgroundVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, fullVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, mobileSecondaryCta?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } };

export type IGetAllStoriesQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<IPublicationState>;
}>;


export type IGetAllStoriesQuery = { __typename?: 'Query', stories?: { __typename?: 'StoryEntityResponseCollection', data: Array<{ __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, publishedAt?: any, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } }, hero?: { __typename?: 'ComponentSharedHero', title?: string, description?: string, showBookingBar?: boolean, showBreadcrumbs?: boolean, bookingBarText?: string, image?: { __typename?: 'ComponentSharedHeroImage', variant: IEnum_Componentsharedheroimage_Variant, descriptionHighlight?: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }, video?: { __typename?: 'ComponentSharedHeroVideo', eyebrowText?: string, backgroundVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, fullVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, mobileSecondaryCta?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } } }> } };

export type IGetBasicPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type IGetBasicPageQuery = { __typename?: 'Query', pages?: { __typename?: 'PageEntityResponseCollection', data: Array<{ __typename?: 'PageEntity', id?: string, attributes?: { __typename?: 'Page', slug: string, createdAt?: any, locale?: string, publishedAt?: any, title: string, updatedAt?: any, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug: string } } } } } }, seo: { __typename?: 'ComponentSharedSeo', metaTitle: string, metaDescription: string, keywords?: string, canonicalURL?: string, metaRobots?: string, customLdJson?: any, metaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } }, metaSocial?: Array<{ __typename?: 'ComponentSharedMetaSocial', socialNetwork: IEnum_Componentsharedmetasocial_Socialnetwork, title: string, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }> } } }> } };

export type IGetPageQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<IPublicationState>;
}>;


export type IGetPageQuery = { __typename?: 'Query', pages?: { __typename?: 'PageEntityResponseCollection', data: Array<{ __typename?: 'PageEntity', id?: string, attributes?: { __typename?: 'Page', showRegionPopup?: boolean, slug: string, createdAt?: any, locale?: string, publishedAt?: any, title: string, updatedAt?: any, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } }, localizations?: { __typename?: 'PageRelationResponseCollection', data: Array<{ __typename?: 'PageEntity', attributes?: { __typename: 'Page', locale?: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } }> }, seo: { __typename?: 'ComponentSharedSeo', metaTitle: string, metaDescription: string, keywords?: string, canonicalURL?: string, metaRobots?: string, customLdJson?: any, metaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } }, metaSocial?: Array<{ __typename?: 'ComponentSharedMetaSocial', socialNetwork: IEnum_Componentsharedmetasocial_Socialnetwork, title: string, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }> }, hero?: { __typename?: 'ComponentSharedHero', title?: string, description?: string, showBookingBar?: boolean, showBreadcrumbs?: boolean, bookingBarText?: string, image?: { __typename?: 'ComponentSharedHeroImage', variant: IEnum_Componentsharedheroimage_Variant, descriptionHighlight?: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }, video?: { __typename?: 'ComponentSharedHeroVideo', eyebrowText?: string, backgroundVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, fullVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, mobileSecondaryCta?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } }, blocks?: Array<{ __typename: 'ComponentBlocksAltContent', backgroundColour?: IEnum_Componentblocksaltcontent_Backgroundcolour, tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, mediaWithContent?: { __typename: 'MediaWithContentRelationResponseCollection', data: Array<{ __typename: 'MediaWithContentEntity', id?: string, attributes?: { __typename?: 'MediaWithContent', title?: string, description?: string, mediaAlignment: IEnum_Mediawithcontent_Mediaalignment, link?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } }, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } }, video?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } } } }> } } | { __typename: 'ComponentBlocksCardsBlock', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, card_collections?: { __typename: 'CardCollectionRelationResponseCollection', data: Array<{ __typename: 'CardCollectionEntity', id?: string, attributes?: { __typename?: 'CardCollection', reverseOrderOnMobile?: boolean, cards?: { __typename?: 'CardRelationResponseCollection', data: Array<{ __typename?: 'CardEntity', id?: string, attributes?: { __typename?: 'Card', Card?: { __typename?: 'ComponentSharedCards', id: string, backgroundColour?: IEnum_Componentsharedcards_Backgroundcolour, tintImage?: boolean, eyebrowText?: string, title?: string, description?: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } }, video?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, link?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } }> } } }> } } | { __typename: 'ComponentBlocksCarouselBlock', slidesPerView: IEnum_Componentblockscarouselblock_Slidesperview, tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, cards?: { __typename?: 'CardRelationResponseCollection', data: Array<{ __typename?: 'CardEntity', id?: string, attributes?: { __typename?: 'Card', Card?: { __typename?: 'ComponentSharedCards', id: string, backgroundColour?: IEnum_Componentsharedcards_Backgroundcolour, tintImage?: boolean, eyebrowText?: string, title?: string, description?: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } }, video?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, link?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } }> } } | { __typename: 'ComponentBlocksCarouselStories', tightPaddingBelow?: boolean, variant?: IEnum_Componentblockscarouselstories_Variant, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, stories?: { __typename?: 'StoryRelationResponseCollection', data: Array<{ __typename?: 'StoryEntity', id?: string, attributes?: { __typename?: 'Story', slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug: string } } } } } }, hero?: { __typename?: 'ComponentSharedHero', title?: string, description?: string, showBookingBar?: boolean, showBreadcrumbs?: boolean, bookingBarText?: string, image?: { __typename?: 'ComponentSharedHeroImage', variant: IEnum_Componentsharedheroimage_Variant, descriptionHighlight?: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }, video?: { __typename?: 'ComponentSharedHeroVideo', eyebrowText?: string, backgroundVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, fullVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, mobileSecondaryCta?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } } }> } } | { __typename: 'ComponentBlocksContacts', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, columns: Array<{ __typename?: 'ComponentSharedContactBlockColumn', title: string, links: Array<{ __typename?: 'ComponentSharedContactColumnLinks', title: string, link: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }> }> } | { __typename: 'ComponentBlocksCustomerRadarFeedbackBlock', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } | { __typename: 'ComponentBlocksDealsBlock', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } | { __typename: 'ComponentBlocksEmbedHtml', id: string, tightPaddingBelow?: boolean, embedCode?: string, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } | { __typename: 'ComponentBlocksEnquiryForm', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } | { __typename: 'ComponentBlocksFaq', ctaDescription?: string, tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, faqs?: { __typename?: 'FaqItemRelationResponseCollection', data: Array<{ __typename?: 'FaqItemEntity', attributes?: { __typename?: 'FaqItem', answer: string, createdAt?: any, question: string, updatedAt?: any } }> }, ctaButton?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } | { __typename: 'ComponentBlocksGallery', tightPaddingBelow?: boolean, galleryImages: Array<{ __typename?: 'ComponentSharedImageField', image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }> } | { __typename: 'ComponentBlocksGalleryCarousel', eyebrowTitle?: string, tightPaddingBelow?: boolean, galleryCarouselImages: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } }> } } | { __typename: 'ComponentBlocksIconCardBlock', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, iconCards?: { __typename: 'IconCardRelationResponseCollection', data: Array<{ __typename?: 'IconCardEntity', id?: string, attributes?: { __typename?: 'IconCard', title?: string, content?: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } } } }> } } | { __typename: 'ComponentBlocksMap', tightPaddingBelow?: boolean, customMarkers?: Array<{ __typename?: 'ComponentSharedMapMarker', location?: any }>, branchLocations?: Array<{ __typename?: 'ComponentSharedBranchLocations', branchLocations?: IEnum_Componentsharedbranchlocations_Branchlocations }> } | { __typename: 'ComponentBlocksMotorhomeDetails', fleet: string, id: string, tightPaddingBelow?: boolean } | { __typename: 'ComponentBlocksMotorhomeInfoTabs', tightPaddingBelow?: boolean, infoTabs: Array<{ __typename?: 'ComponentSharedMotorhomeInfoTab', highlight?: string }> } | { __typename: 'ComponentBlocksRichText', richText: string, tightPaddingBelow?: boolean } | { __typename: 'ComponentBlocksRichTextColumns', addBackgroundColour?: boolean, tightPaddingBelow?: boolean, richTextColumns: Array<{ __typename?: 'ComponentSharedRichTextColumn', richText: string }>, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } | { __typename: 'ComponentBlocksSocialMedia', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, social_posts?: { __typename?: 'SocialPostRelationResponseCollection', data: Array<{ __typename?: 'SocialPostEntity', attributes?: { __typename?: 'SocialPost', url: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } } }> } } | { __typename: 'ComponentBlocksStarStoryForm', tightPaddingBelow?: boolean, aboutDescription?: string, storyDescription?: string, uploadDescription?: string, termsAndConditions?: string, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } | { __typename: 'ComponentBlocksStoryCardGrid', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } | { __typename: 'ComponentBlocksTabContentBlock', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, tabs: Array<{ __typename?: 'ComponentSharedTab', title: string, headingLevel?: IEnum_Componentsharedtab_Headinglevel, columns?: Array<{ __typename?: 'ComponentSharedRichTextColumn', richText: string }> }> } | { __typename: 'ComponentBlocksTestimonials', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, testimonials?: { __typename?: 'TestimonialRelationResponseCollection', data: Array<{ __typename?: 'TestimonialEntity', attributes?: { __typename?: 'Testimonial', author?: string, quote?: string, rating?: number, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } } }> } } | { __typename: 'ComponentBlocksVideo', tightPaddingBelow?: boolean, mux_video_uploader_mux_asset?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } } } | { __typename: 'Error' }> } }> }, stories?: { __typename?: 'StoryEntityResponseCollection', data: Array<{ __typename?: 'StoryEntity', id?: string, attributes?: { __typename?: 'Story', createdAt?: any, publishedAt?: any, updatedAt?: any, locale?: string, slug: string, cmsTitle: string, showRegionPopup?: boolean, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } }, hero?: { __typename?: 'ComponentSharedHero', title?: string, description?: string, showBookingBar?: boolean, showBreadcrumbs?: boolean, bookingBarText?: string, image?: { __typename?: 'ComponentSharedHeroImage', variant: IEnum_Componentsharedheroimage_Variant, descriptionHighlight?: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }, video?: { __typename?: 'ComponentSharedHeroVideo', eyebrowText?: string, backgroundVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, fullVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, mobileSecondaryCta?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } }, localizations?: { __typename?: 'StoryRelationResponseCollection', data: Array<{ __typename?: 'StoryEntity', attributes?: { __typename: 'Story', locale?: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } }> }, seo: { __typename?: 'ComponentSharedSeo', metaTitle: string, metaDescription: string, keywords?: string, canonicalURL?: string, metaRobots?: string, customLdJson?: any, metaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } }, metaSocial?: Array<{ __typename?: 'ComponentSharedMetaSocial', socialNetwork: IEnum_Componentsharedmetasocial_Socialnetwork, title: string, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }> }, blocks?: Array<{ __typename: 'ComponentBlocksCardsBlock', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, card_collections?: { __typename: 'CardCollectionRelationResponseCollection', data: Array<{ __typename: 'CardCollectionEntity', id?: string, attributes?: { __typename?: 'CardCollection', reverseOrderOnMobile?: boolean, cards?: { __typename?: 'CardRelationResponseCollection', data: Array<{ __typename?: 'CardEntity', id?: string, attributes?: { __typename?: 'Card', Card?: { __typename?: 'ComponentSharedCards', id: string, backgroundColour?: IEnum_Componentsharedcards_Backgroundcolour, tintImage?: boolean, eyebrowText?: string, title?: string, description?: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } }, video?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, link?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } }> } } }> } } | { __typename: 'ComponentBlocksCarouselBlock', slidesPerView: IEnum_Componentblockscarouselblock_Slidesperview, tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, cards?: { __typename?: 'CardRelationResponseCollection', data: Array<{ __typename?: 'CardEntity', id?: string, attributes?: { __typename?: 'Card', Card?: { __typename?: 'ComponentSharedCards', id: string, backgroundColour?: IEnum_Componentsharedcards_Backgroundcolour, tintImage?: boolean, eyebrowText?: string, title?: string, description?: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string } } }, video?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, link?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } }> } } | { __typename: 'ComponentBlocksCarouselStories', tightPaddingBelow?: boolean, variant?: IEnum_Componentblockscarouselstories_Variant, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, stories?: { __typename?: 'StoryRelationResponseCollection', data: Array<{ __typename?: 'StoryEntity', id?: string, attributes?: { __typename?: 'Story', slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', slug: string } } } } } }, hero?: { __typename?: 'ComponentSharedHero', title?: string, description?: string, showBookingBar?: boolean, showBreadcrumbs?: boolean, bookingBarText?: string, image?: { __typename?: 'ComponentSharedHeroImage', variant: IEnum_Componentsharedheroimage_Variant, descriptionHighlight?: string, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }, video?: { __typename?: 'ComponentSharedHeroVideo', eyebrowText?: string, backgroundVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, fullVideo?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } }, mobileSecondaryCta?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } } }> } } | { __typename: 'ComponentBlocksContacts' } | { __typename: 'ComponentBlocksDealsBlock' } | { __typename: 'ComponentBlocksFaq', ctaDescription?: string, tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, faqs?: { __typename?: 'FaqItemRelationResponseCollection', data: Array<{ __typename?: 'FaqItemEntity', attributes?: { __typename?: 'FaqItem', answer: string, createdAt?: any, question: string, updatedAt?: any } }> }, ctaButton?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } | { __typename: 'ComponentBlocksGallery', tightPaddingBelow?: boolean, galleryImages: Array<{ __typename?: 'ComponentSharedImageField', image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } }> } | { __typename: 'ComponentBlocksGalleryCarousel', eyebrowTitle?: string, tightPaddingBelow?: boolean, galleryCarouselImages: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } }> } } | { __typename: 'ComponentBlocksMap', tightPaddingBelow?: boolean, customMarkers?: Array<{ __typename?: 'ComponentSharedMapMarker', location?: any }>, branchLocations?: Array<{ __typename?: 'ComponentSharedBranchLocations', branchLocations?: IEnum_Componentsharedbranchlocations_Branchlocations }> } | { __typename: 'ComponentBlocksRichText', richText: string, tightPaddingBelow?: boolean } | { __typename: 'ComponentBlocksRichTextColumns', addBackgroundColour?: boolean, tightPaddingBelow?: boolean, richTextColumns: Array<{ __typename?: 'ComponentSharedRichTextColumn', richText: string }>, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } } } | { __typename: 'ComponentBlocksSocialMedia', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, social_posts?: { __typename?: 'SocialPostRelationResponseCollection', data: Array<{ __typename?: 'SocialPostEntity', attributes?: { __typename?: 'SocialPost', url: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } } }> } } | { __typename: 'ComponentBlocksStoryCardGrid' } | { __typename: 'ComponentBlocksTestimonials', tightPaddingBelow?: boolean, titleDescription?: { __typename?: 'ComponentSharedTitleAndDescription', id: string, eyebrow?: string, title?: string, headingLevel?: IEnum_Componentsharedtitleanddescription_Headinglevel, description?: string, leftAligned?: boolean, showSocialMediaButtons?: boolean, button?: { __typename?: 'ComponentSharedLink', id: string, label: string, linkToExternalPage?: string, linkToPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', id?: string, attributes?: { __typename: 'Page', title: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } }, linkToStory?: { __typename?: 'StoryEntityResponse', data?: { __typename?: 'StoryEntity', id?: string, attributes?: { __typename: 'Story', cmsTitle: string, slug: string, locale?: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string, parentPage?: { __typename?: 'PageEntityResponse', data?: { __typename?: 'PageEntity', attributes?: { __typename?: 'Page', title: string, slug: string } } } } } } } } } } }, testimonials?: { __typename?: 'TestimonialRelationResponseCollection', data: Array<{ __typename?: 'TestimonialEntity', attributes?: { __typename?: 'Testimonial', author?: string, quote?: string, rating?: number, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string, caption?: string, createdAt?: any, ext?: string, formats?: any, hash: string, height?: number, mime: string, name: string, previewUrl?: string, provider: string, provider_metadata?: any, size: number, updatedAt?: any, url: string, width?: number } } } } }> } } | { __typename: 'ComponentBlocksVideo', tightPaddingBelow?: boolean, mux_video_uploader_mux_asset?: { __typename?: 'MuxVideoUploaderMuxAssetEntityResponse', data?: { __typename?: 'MuxVideoUploaderMuxAssetEntity', attributes?: { __typename?: 'MuxVideoUploaderMuxAsset', aspect_ratio?: string, asset_id?: string, createdAt?: any, duration?: number, error_message?: string, isReady?: boolean, playback_id?: string, title: string, updatedAt?: any, upload_id?: string, thumbnailTime?: number } } } } | { __typename: 'Error' }> } }> } };
